import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Modal as AntModal,
  Input,
  Popover,
  Tabs,
  Button,
  Badge,
  theme,
  Select,
  Tooltip,
  Checkbox,
  Popconfirm,
  Space,
  DatePicker,
  Typography,
  message,
  Switch,
  Radio
} from "antd";
import "./CreateTaskModal.css";
import Config from '../../config.json'
import { Row, Col} from "reactstrap";
import dayjs from "dayjs"; 
import { setNotificationFlag } from "../../Context/ReduxContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faUser,
  faClock,
  faFolder,
  faPaperclip,
  faCodeBranch,
  faArrowLeft,
  faTimes,
  faCheck,
  faAngleRight,
  faPlus,
  faMinus,
  faTrashAlt,
  faFilter,
  faArrowDown,
  faArrowUp,
  faComments,
  faCog,
} from "@fortawesome/free-solid-svg-icons"; 
import { CaretDownFilled, CloseOutlined, FlagFilled, InfoCircleOutlined} from "@ant-design/icons";
import { faCommentAlt, faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { UserPicker } from "../../common/UserPicker/UserPicker";
import { AppDataRequired } from "../../App";
import SubTaskTab from "./AddTaskTabs/SubTaskTab";
import { Checklist } from "./AddTaskTabs/Checklist";
import { ActivitySection } from "./AddTaskTabs/ActivitySection";
import TextArea from "antd/es/input/TextArea";
import { CustomeCollapse } from "./AddTaskTabs/CustomeCollapse";
import AppContext from "../../Context/AppContext";
import AwsServerService from "../../common/util/AwsServerService";
import _ from 'lodash';
import swal from "sweetalert";
import {convertToUSTime,getPriorityValue, invertColor,} from "../../components/HR/TimeClock/Util";
import { Option } from "antd/es/mentions";
import { i, number } from "mathjs";
import CustomTimeSelect from "../../common/CustomTimeSelect/CustomTimeSelect";
import TimeTracker from "../../common/TimeTracker/TimeTracker";
import {checkForAccessLevel, getNextStepOfFlow} from '../../components/ProjectTasks/Util'
import AttachmentModal from "./attachmentModal";
import axios from "axios";
import SettingIconDark from '../../assets/images/svg/SettingIconDark.svg';
import StatusTimelineIcon from '../../assets/images/svg/StatusTimeline.svg';
import { TaskFlowStatus } from "./TaskStatus/TaskFlowStatus";
import DependencyModal from "./ViewPipelinesTabs/DependencyModal";
import { evaluateEdgeVisibility } from "../../Util/CommonUtil";
import { modifyEdgesAndNodes, processEdgeConnections, updateNodeVisitedStatus } from "./TaskUtil";
import { Flow } from "../../components/TaskBluePrints/Flow";
import Loader from "../../common/loader";
import { InputFields } from "../../components/InputFields/InputFields";
import { InputFieldsTable } from "../../components/InputFields/InputFieldsTable";
import { Socket } from "../../Context/AppActions";
import moment from "moment";
import { NewCustomePopover } from "../../components/TaskBluePrints/HelperComponents/NewCustomePopover";
import { StatusTimeline } from "./StatusTimeline/StatusTimeline";
import JoditTextEditor from "../../common/JoditEditor/JoditTextEditor";
import TaskService from "../../common/util/TaskService";
import ReminderForTasks from "./ViewPipelinesTabs/ReminderForTasks";
import { useDispatch, useSelector } from "react-redux";
import { ResetInputFieldValidation } from "../../Context/ReduxContext";
import EmailService from "../../common/util/EmailService";
import { checkReminder } from "../../components/TaskBluePrints/Reminder/ReminderUtil";
import httpService from "../../services/http.service"; 
import Email from "../../components/EmailSection/email";
import EmailChatSection from "./ViewPipelinesTabs/EmailChatSection";
import Swal from "sweetalert2";
import RenderSettingsPopoverContent from "./RenderSettingPopoverContent";
import TaskCommentSection from "./TaskCommentSection";
import TaskSidebarContentRenderer from "./TaskSidebarContentRenderer";
import { canAccess, getTaskAccess } from "../../../src/common/util/appUtils";

const { Search } = Input;
const { OptGroup } = Select;
const { Title } = Typography;
const CustomeTaskField = ({ name, icon, children ,type}) => {
  return (
    <Row className="Custom-Field-Row" sm={12}>
      <Col style={{ padding: "0px" }} sm={4}>
        <Row sm={12}>
          <Col style={{ padding: "0px" }} sm={2}>
            {icon}
          </Col>
          <Col style={{ padding: "0px 3px", fontWeight: "500", fontSize: "12px" }} sm={10}>
            {name}
          </Col>
        </Row>
      </Col>
      <Col sm={8}>{children}</Col>
    </Row>
  );
};

const CreateTaskModal = ({
  open,
  history,
  insertBelowData,
  setOpen,
  viewTaskData,
  taskModalState,
  viewPipelineData,
  refreshData,
  setPageRefreshData,
  createPiplineModalState,
  selectedTable,
  isSubTaskView,
  setIsSubTaskView,
  allPipelineData,
  viewTaskFunction,
  dropdownTasksDataCache,
  allTasksAndSubtasks,
  allBlueprintsData,
  dependencyRefresh,
  setDependencyRefresh,
  getHeaderForDeal,
  setDropdownTasksDataCache,
  setTaskModalState,
  allAccounts,
  setRefreshTasksSubtasks,
  allDependeniesData,
  handleNotificationHyperlink,
  getParams,
  location,
  isTaskModalClosed,
  DealName,
  fromBody,
  dealObj,
  accessedFromAccounts
}) => {

  const AppReduxContextDispatch = useDispatch(); // Dispatch actions
  const AppReduxContext = useSelector((state) => state.AppReduxContext); // Read state
  const getNotification = useSelector((state) => state.AppReduxContext.getNotificationFlag);
  const moduleContacts = useSelector((state) => state.AppReduxContext.moduleContacts);
  const accessContext = useSelector(state => state.UserContext.accessContext);
  const [isBlueprintOpen, setIsBlueprintOpen] = useState(false);
  const originalTaskNameRef = useRef("");
  originalTaskNameRef.current = viewTaskData?.Task?.TaskName || originalTaskNameRef.current;
  // const backendUrl = "https://catly-795086611.catalystserverless.com/server/apiservice/";
  const backendUrl = Config.backend_aws_server_url;
  const { token } = theme.useToken();
  const userInfo = JSON.parse(localStorage.getItem('userinfo'));
  const [loader,setLoader] = useState(false);
  const [accountSelected, setAccountSelected] = useState();
  // const [openRangePicker,setOpenRangePicker] = useState(false);
  const timeline = useRef(null);
  const [scrollBottom, setScrollBottom] = useState(0);
  const [allCriteriaFields,setAllCriteriaFields] = useState({})
  // const [MissingRoleUsers,setMissingRoleUsers]=useState([]);
  // const [MissingRoleUserLabel,setMissingRoleUserLabel]=useState([]);

  const accessControlData = useRef([]);
  const [canEdit, setCanEdit] = useState("NO");
  const [canDelete, setCanDelete] = useState("NO");
  const [canCreate, setCanCreate] = useState("NO");
  const checkAccess = async () =>{
    if(selectedTable == "tasks"){
      if(viewTaskData && viewTaskData?.Task && viewTaskData?.Task != null){
      const viewTaskAccess = await getTaskAccess(viewTaskData?.Task, accessContext, AllUsers, userInfo);
      setCanEdit(viewTaskAccess[0]?.canEdit || "NO");
      setCanDelete(viewTaskAccess[0]?.canDelete || "NO");
      }else{
        setCanEdit("YES");
        setCanDelete("NO");
      }
    }else if(selectedTable == "pipelines" || selectedTable == "pipeline"){
      const Create = canAccess(accessContext, "Pipeline Template", "Create");
      const Edit = canAccess(accessContext, "Pipeline Template", "Edit");
      const Delete = canAccess(accessContext, "Pipeline Template", "Delete");
      setCanEdit(Edit || "NO");
      setCanDelete(Delete || "NO");
      setCanCreate(Create || "NO");
    }else{
      const Edit = canAccess(accessContext, "Pipeline", "Edit");
      const Delete = canAccess(accessContext, "Pipeline", "Delete");
      setCanEdit(Edit || "NO");
      setCanDelete(Delete || "NO");
    }
  }
  useEffect(()=>{
    let data = {};
    const accessPromise = AwsServerService.CrudServiceHandler({method: 'GET',data: '',route: 'ACCESSCONTROL'});
    const teamsPromise = AwsServerService.CrudServiceHandler({method: 'GET',data: '',route: 'TEAMS'}); 
    Promise.all([accessPromise, teamsPromise])
      .then(([accessRes, teamsRes]) => {
        accessRes?.data?.forEach(r=>{ 
            data[r.FlowID] = { AccessData: r?.AccessData || [], TeamsData: teamsRes?.data || [] };
        }) 
      accessControlData.current=data;
    })
  },[])
  const [selectedBlueprintData,setSelectedBlueprintData] = useState({
    type: "view flow",
    data: null,
    action: "view"
})
  const [dealSelected, setDealSelected] = useState();
  const [accessType, setAccessType] = useState("read");
  const [taskFLowReminders,setTaskFlowReminders] = useState([]);
  const [statusTimeline,refreshStatusTimeline] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [taskHistory, setTaskHistory] = useState([]); 
  const [statusOptions, setStatusOptions] = useState([]);
  const [mainStatusOptions, setMainStatusOptions] = useState([]);
  const [attachmentModal, setAttachmentModal] = useState(false);
  const [fileNames, setFileNames] = useState([]);
  const [lookUpDeal, setLookUpDeal] = useState();
  const [relativePathId, setRelativePathId] = useState("");
  const [filteredDropdownTasksData,setFilteredDropdownTasksData]=useState([]);
  const [BluePrintDropDownOptions,setBluePrintDropDownOptions] = useState([]);
  const [availableFlowDropDownOptions,setAvailableFlowDropDownOptions] = useState([]);
  const [transitionChangeState,setTransitionChangeState]=useState(false);
  const [updateFlag, setUpdateFlag] = useState(false);
  const [allCacheRoles,setAllCacheRoles] = useState([])
  const [allCacheUserRoles,setAllCacheUserRoles] = useState([])
    ////// Attachment Functions /////
    const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
        fileReader.onerror = (error) => {
          reject(error);
        };
      });
    };


    const convertToBase64Format = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(',')[1]);  
        reader.onerror = reject;
        reader.readAsDataURL(file);  
      });
    };

    const handleAttachementRemove = (one) => {
      let tempFileCollection = [...fileNames];
      tempFileCollection = tempFileCollection.filter((file) => file.fileName !== one.fileName);
      setFileNames(tempFileCollection);
    }
    const fetchReminders = ({ ROWID }) => {
      if (ROWID) {
        AwsServerService.CrudServiceHandler({ method: "GETWHERE", data: { TaskFlowId: ROWID }, route: "TASKFLOWREMINDER" }).then(res => {
          setTaskFlowReminders(res.data);
          // setAllCacheRoles(res.data);
        }).catch(err => {
          console.log(err);
        })
      }
    }
    const fetUserRoles = () => { 
      AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "USERROLES" }).then(res => {
          // setAllUserRoles(res.data); 
          setAllCacheUserRoles(res.data);
      }).catch(err => {
          console.log(err);
      })
  }
    const fetRoles = () => {
      AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "ROLES" }).then(res => {
          // setAllRoles(res.data);
          setAllCacheRoles(res.data);
      }).catch(err => {
          console.log(err);
      })
  }
      useEffect(e=>{
        fetUserRoles();
        fetRoles();
      }, [])
    const uploadFiles = (arr) => {
      let doArr = []
      let fileUploadArr = []
      let names = []
      let tempFileCollection = [...fileNames];
      tempFileCollection.forEach((obj) => {
        obj.Status = "Pending"
      })
      arr.forEach((one) => {
        names.push(one.fileName);
        // doArr.push(addZohoTaskAttachements(taskData.project_id, taskData.id_string, one))
        fileUploadArr.push(handleUploadFileWorkDrive(one))
      })
  
      // setProgress({ active: true, percent: 1 })
      // let startInterval = setInterval(() => {
      //   setProgress((prev) => {
      //     if (prev && prev.percent < 100) {
      //       prev.percent = prev.percent + 1;
      //       setProgress(prev);
      //     }
      //   })
      // }, 1)
      Promise.all(doArr)
        .then((result) => {
  
          console.log(result);
  
          return Promise.all(fileUploadArr)
        })
        .then((result) => {
          arr.forEach((one) => {
            one.Status = "Success"
          })
  
          // setProgress({ active: true, percent: 100 });
          let filterTemp = tempFileCollection.filter(e => e.Status != "Success")
          // setLoader(false);
          setFileNames(filterTemp);
          // clearInterval(startInterval);
          // setProgress({ active: false, percent: 0 });
          alert("file upload successfully");
          // setAttachmentModal(false)
          console.log(result);
        })
        .catch((err) => {
          console.log(err);
        }) 
    }

    useEffect(e=>{
      if(viewTaskData?.SubTask){
        AwsServerService.getSubTaskById(viewTaskData?.SubTask?.TaskRowId).then(res=>{
          let k=res[0]?.taskInfo;
          if(k){
            handleHistoryAdd();
            viewTaskFunction(k,"TASK");
            setLoader(false)
          }
        }).catch(e=>{
          setLoader(false);
        })
      }else{
        AwsServerService.getTaskById(viewTaskData?.Task?.TaskROWID).then(res=>{
          let k=res[0]?.taskInfo;
          if(k){
            handleHistoryAdd();
            viewTaskFunction(k,"TASK");
            setLoader(false)
          }
        }).catch(e=>{
          setLoader(false);
        }) 
      }
    },[updateFlag])

    const handleUploadFiles = () => {
      let link = document.createElement('input');
      link.setAttribute('type', 'file');
      link.setAttribute('name', 'uploadFiles');
      link.setAttribute('multiple', "multiple");
      document.body.appendChild(link);
      link.click();
      link.onchange = function (e) {
        // let formData = new FormData();
        // formData.append('uploaddoc', e.currentTarget.files[0])
        // updateZohoTask(formData)
        handleFileAttachments(e.currentTarget.files);
      }
  
      document.body.removeChild(link);
    }
    useEffect(() => {
      if (lookUpDeal?.Deal_Name) {
        AwsServerService.ensureFolderPathExists(lookUpDeal.zohoworkdriveforcrm__Workdrive_Folder_ID, ["Documents", "Task"], localStorage.getItem('token')).then(ParentFolderId => {
          if (ParentFolderId) {
            setRelativePathId(ParentFolderId)
          }
        })
      }
    }, [lookUpDeal])
    const getBreadCrumbs = (task) => {
      if(!viewTaskData){
       return;
      }
     if(task.SubTaskId && task.TaskRowId){
         let t=viewTaskData?.Task;
         let pipeline=viewTaskData?.Pipeline;
       if(!pipeline || !t){
         return<></>
       }
       return <>
         <span style={{position:"relative", top:"2px", fontWeight: "700"}}><FontAwesomeIcon icon={faAngleRight} /></span>
         <Tooltip color="rgb(54 54 54)" title={t.TaskName}>
         <span style={{
           backgroundColor: "#5b6c97",
           color: "white",
           maxWidth: "6rem"
         }} className='Group1-Card Elipsis-Class'  onClick={() => {
                AwsServerService.getTaskById(t?.TaskId).then(res=>{
                let k=res[0]?.taskInfo;
                if(k){
                  handleHistoryAdd()
                  viewTaskFunction(k,"TASK");
                }
              }).catch(e=>{
                // setLoader(false);
              })
         }}>{t.TaskName}</span>  
         </Tooltip>
        </>
     }
 }
  const handleUploadFileWorkDrive = (fileObj) => {
    return new Promise((resolve, reject) => {
      if (relativePathId) {
        var config = {
          Type: "Upload",
          data: {
            filename: fileObj.fileName,
            content: fileObj.file,
            parent_id: relativePathId,
          },
          url: "https://www.zohoapis.com/workdrive/api/v1/upload",
          method: "POST",
          headers: {
            'Authorization': localStorage.getItem('token')
          }
        };
        axios.post(backendUrl + "catalyApi/workdrive", { config: config })
          .then(async function (response) {
            // ActivitieService.AddActivityLocal('Workdrive', { DealId: props.dealObj.Project_ID }, { action_type: 'Upload', data_type: 'File', data: { name: fileObj.fileName, path: relativeFolderId, pathId: relativePathId } })
            // resolve(response)
            // console.log("-------------------------files data-----------------------------------")

          })
          .catch(function (error) {
            reject(error);
          });
      }
    })
  }

  const handleFileAttachments = async (fileList) => {
    let tempFileCollection = [...fileNames];
    let length = fileList.length;
    let index = 0;
    while (index < length) {
      let fileName = fileList[index].name;
      let type = fileList[index].type;
      let base64 = await convertToBase64(fileList[index]);
      tempFileCollection.push({
        fileName: fileName,
        file: base64,
        type: type
      });
      index = index + 1;
    }
    setFileNames(tempFileCollection);

  };
    ////// Attachment Functions /////
  let dueDate=new Date();
  const taskEmptyTemplate = {
    TaskName: "",
    TaskDescription: "",
    Priority: "Not Set",
    Assignee: "",
    Supervisor: "",
    PipelineROWID: "",
    DueDate: new Date(),
    StartDate:new Date(),
    Account: "",
    Project: "",
    TaskTemplateId: "",
    TaskStatus:1,
    // TaskFlowId:'1',
    TimeEstimate: "",
    SubTasks: [],
    CheckList: [],
    InputFields:[],
    LookUpFields:[],
    TaskFlowObject:null,
    IsMilestone : 0,
  };
  
  const [taskData, setTaskData] = useState({ ...taskEmptyTemplate });
  const { AllUsers } = useContext(AppDataRequired);
  const { DealFields } = useContext(AppDataRequired);
  const [userOptions, setUserOptions] = useState([]);
  const [transitionEmails, setTransitionEmails] = useState([]);
  const [linksForAttachment, setLinksForAttachments] = useState([]);
  const [allAccountsData, setAllAccountsData] = useState([]);
  const [allDealsData, setAllDealsData] = useState([]);
  const [allPipelinesData, setAllPipelinesData] = useState([]);
  const [isDependencyModalOpen, setIsDependencyModalOpen] = useState(false);
  const [subTaskData, setSubTaskData] = useState([]);
  const AppData = useContext(AppContext);
  const { state, dispatch } = AppData || {};
  let allDealsAndUsers = useSelector((state) => state.AppReduxContext.AllDeals || []);
  let AllDeals = useSelector((state) => state.AppReduxContext.AllDeals || []); // using again becasue we used filter and map on allDealsAndUsers
  // let allAccounts = state.AllAccounts || [];
  // const  comment = useRef({ROWID:null,flag:false});
  const [dropdowncount,setDropdownCount]=useState({WaitingOn:0,Blocking:0}); 
  let userinfo = JSON.parse(localStorage.getItem("userinfo"));
  const [selectedDependenciesCache,setSelectedDependenciesCache]=useState({WaitingOn:[], Blocking:[]})
  const [allDependencies,setAllDependencies]=useState([])
  const [selectedDependencies,setSelectedDependencies]=useState({
    WaitingOn:[],
    Blocking:[]
  }); 
  const clockInterval=useRef(null);
  const [startTimer, setStartTimer] = useState(false)
  const [description, setDescription] = useState('');
  const [anotherSessionActiveFlag, setAnotherSessionActiveFlag] = useState({Active:false,Record:{}});
  const [lastEntry, setLastEntry] = useState(null); 
  const [userList, setUserList] = useState([]);
  const [timer3, setTimer3] = useState(0);
  const [timer, setTimer] = useState(0); 
  const [timer2, setTimer2] = useState(0); 
  const [typeOfTask, setTypeOfTask] = useState({ROWID:'',Type:''});
  const [selectedActivityFilter, setSelectedActivityFilter] = useState([]);
  const [activityFilter, setActivityFilter] = useState({Sort:"DESC",SearchText:''});
  const [isPopConfirmVisible, setIsPopConfirmVisible] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  let allAppUsers = state.AllAppUsers || [];
  function calculateTimeDifference(startTime, stopTime) { 
    const start = moment(startTime);
    const stop = moment(stopTime); 
    const duration = moment.duration(stop.diff(start)); 
    return duration.asSeconds();
  } 
  const formatTime = (timer) => {
    const getSeconds = `0${timer % 60}`.slice(-2);
    const minutes = `${Math.floor(timer / 60)}`;
    const getMinutes = `0${minutes % 60}`.slice(-2);
    const getHours = `0${Math.floor(timer / 3600)}`.slice(-2);

    return `${getHours}:${getMinutes}:${getSeconds} Hrs`;
  };
  const checkRecordIfAvailable = (taskId, taskType) => {
    let tp=taskType=='Tasks'?'Task':'Sub-Task';
    AwsServerService.getAllTimelineBYIDANDTYPE(taskId,tp).then(rspons=>{
       
      const response=rspons.data;
      AwsServerService.getTimeRecordsByTask(taskId, taskType).then(r => {
      const data = r.data; 
      let obj = {};
      data.forEach(entry => {
        if (obj[entry.CreatedBy]) {
          obj[entry.CreatedBy].push(entry);
        } else {
          obj[entry.CreatedBy] = [entry];
        }
      });
      let totalSeconds = 0;
      let taskRecord = {};
      let flag = true;
      let userLists = [];
      Object.keys(obj).forEach(e => {
        let info = userOptions.find(el => el.value == e);
        let totalSec = 0;
        obj[e].forEach(record => {
          if (record.StopTime == '-' && flag == true) {
            const now = new Date();
            const StopTime = convertToUSTime(now);
            const { StartTime } = record;
            totalSeconds += calculateTimeDifference(StartTime, StopTime);
            let currentSessionTime = calculateTimeDifference(StartTime, StopTime);
            setTimer2(currentSessionTime);
            setTimer3(currentSessionTime);
            setStartTimer(true);
            taskRecord = record;
            flag = false;
          } else {
            const { StartTime, StopTime } = record;
            totalSeconds += calculateTimeDifference(StartTime, StopTime);
            totalSec += calculateTimeDifference(StartTime, StopTime);
          }
        })
        let object = {
          userName: info?.label,
          userId: info?.value,
          Entrys: obj[e],
          TotalTime: formatTime(totalSec)
        }
        userLists.push(object);
      })
      setTimer(totalSeconds);
      if (!flag) {
        setLastEntry(taskRecord);
      }
       
      let dummyUserList=[];
      userLists.forEach(element=>{
      let entrys={};
      for(let i=0;i<response.length;i++){ 
        let firstTime=response[i].UTCTimeString;
        let secondTime='';
        let nextEntry=response.find(k=>k.UTCTimeString>firstTime);
        if(nextEntry){ 
          secondTime=nextEntry.UTCTimeString;
        }else{
          const now = new Date();
          secondTime= convertToUSTime(now);
        }; 
        let records=element['Entrys'].filter(e=>e.StartTime>firstTime && (e.StopTime<secondTime || e.StopTime=='-'));
        if(records.length>0){ 
          if(entrys[`${response[i].TaskStatus.data.label}_${response[i].TaskStatus.data.color}`]){
            entrys[`${response[i].TaskStatus.data.label}_${response[i].TaskStatus.data.color}`].push(...records)
          }else{
            entrys[`${response[i].TaskStatus.data.label}_${response[i].TaskStatus.data.color}`]=[...records]
          }
        }
       }
      dummyUserList.push({...element,Entrys:entrys})
      })
      setUserList(dummyUserList);
       
    })
  })
  }
  const checkForActiveTrackingSessions = () => {
    AwsServerService.getAllTimeRecordsWithDash().then(r => {
      let data = r.data;
      let flag = false;
      let record = {};
      for (let i = 0; i < data.length; i++) {
        if (data[i].StopTime == '-') {
          flag = true;
          record = data[i];
        }
      }
      let tasksD = { ...allTasksAndSubtasks };
      if (record && record.TaskType == 'Tasks') {
        const newData = tasksD.Tasks.get(number(record.TaskROWID));
        record['TaskName'] = newData?.TaskName;
      } else if (record && record.TaskType == 'SubTasks') {
        const newData = tasksD.SubTasks.get(number(record.TaskROWID));
        record['TaskName'] = newData?.TaskName;
      }
      setAnotherSessionActiveFlag({ Active: flag, Record: record });
    })
  }
  const updateTaskFields = (data) => {
    if(canEdit == "NO" && selectedTable == "tasks") { 
      message.error("Permission Denied"); 
      return
    }
   if(accessType=="read"||accessType=='none'){
    message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
    return;
    }
    const updateService = selectedTable == "tasks" ? 
     (isSubTaskView ? AwsServerService.updateSubtask : AwsServerService.updateTask)
    : 
    (isSubTaskView ? AwsServerService.updateSubtaskInTemplate : AwsServerService.updateTaskInTemplate)
  
    updateService(data)
      .then((res) => {
        // setPageRefreshData(prev => !prev);
        dispatch(Socket({ trigger: "refresh_activity", data: '' }))
      })
      .catch(er => console.log("Er", er)).finally(e => {
        dispatch(Socket({ trigger: "refresh_activity", data: '' }))
      })
  };
  const updateTaskData = (data, field, val,isObject) => {
    if(canEdit == "NO" && selectedTable == "tasks") { 
      message.error("Permission Denied"); 
      return
    }    
    let data2 = {}
    if(field && (val || field=='IsMilestone') && !isObject){
      data2 = {
        ROWID: !isSubTaskView ? data.TaskROWID : data.SubTaskROWID,
        [field]: val || (field=='IsMilestone'? 0 : ""),
        MODIFIEDBY: userInfo.email_id,
      };
    }else if(isObject){
      data2 = {
        ROWID: !isSubTaskView ? data.TaskROWID : data.SubTaskROWID,
        MODIFIEDBY: userInfo.email_id,
        ...isObject
      };
    }
    
    const updateService = selectedTable == "tasks" ? 
     (isSubTaskView ? AwsServerService.updateSubtask : AwsServerService.updateTask)
    : 
    (isSubTaskView ? AwsServerService.updateSubtaskInTemplate : AwsServerService.updateTaskInTemplate)
    
    updateService(data2)
    .then(async(res) => {
      if(selectedTable == "tasks"){
         if(field == 'IsMilestone'){
          const message = `USER ${val ? "marked": "unmarked"} this task as milestone.`;
                  handleCreateActivity("TASK", 'Tasks', message, data2?.ROWID);
          await AwsServerService.checkIfMilestonePresent(taskData?.PipelineROWID, selectedTable).then(res=>{
               
               if(res.data && res.data.length == 0){
                 AwsServerService.updatePipeline({ROWID:data.PipelineROWID, IsMilestone:0});
               }else if(res.data && res.data.length > 0){
                 AwsServerService.updatePipeline({ROWID:data.PipelineROWID, IsMilestone:1});
               }
            }) 
        }
        let zuidArr = [];
        if(field == "Assignee" || field == "Supervisor" || field == "Priority" || field == "TimeEstimate" || field == "PipelineROWID" || isObject){
          // const taskType = data.hasOwnProperty("PipelineROWID") ? "task" : "subtask" == "task" ? "Task" : "Sub Task";
          const taskType = data.SubTaskROWID ? "Sub Task" : "Task"
          let text = '';
          if(field == "Assignee"){
            text = '';
            zuidArr.push(val);
          }else if(field == "Supervisor"){
            text = `assigned you as supervisor in ${taskType}`
            zuidArr.push(val)
          }else if(field == "Priority"){
            const oldPriorityColor = getPriorityValue(data.Priority); // Get color for old priority
            const newPriorityColor = getPriorityValue(val); // Get color for new priority
            text = (
              <>
                changed priority from{' '}
                <span style={{ color: oldPriorityColor, fontWeight: 'bold' , whiteSpace:"nowrap"}}>
                <FlagFilled style={{ color: oldPriorityColor }} />{' '}
                  {data.Priority}
                </span>{' '}
                to{' '}
                <span style={{ color: newPriorityColor, fontWeight: 'bold', whiteSpace:"nowrap" }}>
                <FlagFilled style={{ color: newPriorityColor }} />{' '}
                  {val}
                </span>
                <span>{' '} in {taskType}</span>
              </>
            );
            zuidArr = [...zuidArr, data.Assignee, data.Supervisor]
          }else if(field == "TimeEstimate"){
            const oldTimeesimate = data.TimeEstimate;
            const newTimeEstimate = val;
            text = (
              <>
                updated the Time Estimate from{' '}
                <span style={{fontWeight: 'bold'}}>{oldTimeesimate}</span>{' '}
                to{' '}
                <span style={{fontWeight: 'bold'}}>{newTimeEstimate}</span>
                <span>{' '} in {taskType}</span>
              </>
            );
            zuidArr = [...zuidArr, data.Assignee, data.Supervisor]
          }else if(field == "PipelineROWID"){
            const oldPipeline = allPipelinesData.find(item => item?.value == data?.PipelineROWID)?.label;
            const newPipeline = allPipelinesData.find(item => item?.value == val)?.label;
            text = (
              <>changed Pipeline from{" "}
                <span>{oldPipeline}</span>{" "}
                to{" "}
                <span>{newPipeline}</span>
                <span>{' '} in {taskType}</span>
              </>
            )
            zuidArr = [...zuidArr, data.Assignee, data.Supervisor]
          }else if(isObject){
            const oldDueDate = dayjs(data?.DueDate);
            const newDueDate = dayjs(isObject?.DueDate);
            if (!oldDueDate.isSame(newDueDate, "day")) {
              const oldFormatted = oldDueDate.format("MM-DD-YYYY");
              const newFormatted = newDueDate.format("MM-DD-YYYY");
              text = (
                <>Due Date changed from{" "}
                  <span>{oldFormatted}</span>{" "}
                  to{" "}
                  <span>{newFormatted}</span>
                  <span>{' '} in {taskType}</span>
                </>
              )
            zuidArr = [...zuidArr, data.Assignee, data.Supervisor]
            }
          }
  
          const renderToHtml = (element) =>
          require('react-dom/server').renderToString(element);
          await TaskService.SendAssignedNotification(zuidArr,allAppUsers,data,lookUpDeal,taskType, (field != "Assignee" && renderToHtml(text)), allTasksAndSubtasks).then(e=>{
            AppReduxContextDispatch(setNotificationFlag(!getNotification));
          }).catch(e=>{})
        }
      }else{
        if(field == 'IsMilestone'){
          const message = `USER ${val ? "marked": "unmarked"} this task as milestone.`;
                  handleCreateActivity("TASK", 'Tasks', message, data2?.ROWID, true);
          await AwsServerService.checkIfMilestonePresent(taskData?.PipelineROWID, selectedTable).then(res=>{
               
               if(res.data && res.data.length == 0){
                 AwsServerService.updatePipelineInTemplate({ROWID:data.PipelineROWID, IsMilestone:0});
               }else if(res.data && res.data.length > 0){
                 AwsServerService.updatePipelineInTemplate({ROWID:data.PipelineROWID, IsMilestone:1});
               }
            }) 
        }
      }
      // setPageRefreshData(prev => !prev);
    })
      .catch(er => console.log("Er", er)).finally(e => {
        dispatch(Socket({ trigger: "refresh_activity", data: '' }))
      })
  };
  useEffect(()=>{
    if(dealSelected && taskData){ 
      let type = taskData?.hasOwnProperty('SubTaskROWID')?'SubTask':'Task';
      let taskROWID=taskData?.hasOwnProperty('SubTaskROWID')?taskData?.SubTaskROWID:taskData?.TaskROWID;
      AwsServerService.getEmailAttachmentLink(dealSelected,taskROWID,type).then(ress=>{
        setLinksForAttachments(ress?.data);
      })
    }
  },[taskData,dealSelected])
  useEffect(()=>{
    checkAccess();
    if(open && !viewTaskData){
      let flowObj= allBlueprintsData?.filter(e=>e.DefaultFlow=="true")[0]; 
      if (flowObj) {
        let status = flowObj.Nodes.find(k=>k.NonSelectable);
        setSelectedBlueprintData({...selectedBlueprintData,data:flowObj})
        let ob={ ...taskData ,TaskStatus:status?.id,TaskFlowId:flowObj?.ROWID, TaskFlowObject:flowObj};
        if(viewPipelineData && viewPipelineData?.length > 0){
          ob["PipelineROWID"] = viewPipelineData[0]?.PipelineROWID || viewPipelineData[0]?.ROWID;
          let array = [];
            array.push({
              value: viewPipelineData[0]?.PipelineROWID || viewPipelineData[0]?.ROWID,
              label: viewPipelineData[0]?.PipelineName,
              key: viewPipelineData[0]?.PipelineROWID || viewPipelineData[0]?.ROWID,
            });
            setAllPipelinesData(array);
        }else{
          setAllPipelinesData([]);
        }  
        if(insertBelowData.SubTask){  
            ob["TaskROWID"] = insertBelowData.Position
            ob["PipelineROWID"] = insertBelowData.PipelineROWID 
            let deal=allPipelineData?.find(e=>e.PipelineROWID==insertBelowData?.PipelineROWID)['DealName']
          let account = allDealsAndUsers?.filter(e => e.Deal_Name == deal ? e?.Account_Name : '')
          setAccountSelected(account[0]?.Account_Name?.name)
          setDealSelected(deal);
        }else if(insertBelowData.PipelineROWID){ 
          ob["PipelineROWID"] = insertBelowData.PipelineROWID 
          let deal=allPipelineData?.find(e=>e.PipelineROWID==insertBelowData?.PipelineROWID)['DealName']
          let account = allDealsAndUsers?.filter(e => e.Deal_Name == deal ? e?.Account_Name : '')
          setAccountSelected(account[0]?.Account_Name?.name)
          setDealSelected(deal);
        }else if(fromBody){
          if(accessedFromAccounts){
            setAccountSelected(dealObj[0]?.Client?.name);
          }else{
            setAccountSelected(dealObj?.Account_Name?.name)
            setDealSelected(dealObj?.Deal_Name);
          }
        }
        getBlueprintDataOptions(ob, ob.TaskStatus);
        originalTaskNameRef.current = ob?.TaskName;
        setTaskData(ob);
      }
    }
  },[open])
  
  useEffect(e => {
    if(taskData.TaskFlowId){
      fetchReminders({ROWID:taskData.TaskFlowId});
      AwsServerService.getTransitionEmailByIdParam(taskData.TaskFlowId).then(res=>{
        if(res.data && res.data.length>0){
          setTransitionEmails(res.data);
        }else{
          setTransitionEmails([]);
        }
      })
    }
  }, [taskData.TaskFlowId])
  useEffect(e=>{
    if(taskData && dealSelected && allDealsAndUsers){
      let deal = allDealsAndUsers.find(d=> d.Deal_Name == dealSelected);
      setLookUpDeal(deal)
    }
  }, [taskData, allDealsAndUsers, DealFields ,dealSelected])
  
  useEffect(e=>{
    if(DealFields && DealFields?.length > 0){
      setFilteredFields(DealFields)
    }
  }, [DealFields]);

  const handleCreateNotification = async (notifyArraytoPass, AllUsers, datafor, text) =>{
    await TaskService.SendNotificationToMultipleUsers(notifyArraytoPass ,AllUsers, datafor, text )
      .then((e) => {
        AppReduxContextDispatch(setNotificationFlag(!getNotification));
      })
      .catch((e) => {
        console.log("e", e);
      });
  }

  let clientColor='#5b6c97';
  let dealColor='rgb(91, 108, 151)';
 
  useEffect(()=>{
    if(lookUpDeal){
    TaskService.GetClientColor(lookUpDeal.Account_Name.id).then(res=>{  
      clientColor=res;
    }).catch(err=>{
      console.log(err)
    })
     TaskService.GetDealColor(lookUpDeal.Stage).then(res=>{ 
      dealColor=res;
    }).catch(err=>{
      console.log(err)
    })
    }
  },[lookUpDeal])
 const sendSubTaskNotification = async (data) => {
    const parentTask = allTasksAndSubtasks.Tasks.get(data.TaskROWID);
    let zuidArr = [];
    let text = '';
      text = (
        <>
          Created Subtask {' '}
          <span style={{ fontWeight: 'bold' , whiteSpace:"nowrap"}}>
            {data.TaskName}
          </span>{' '}
          for Task{' '}
        </>
      );
      zuidArr = [...zuidArr, parentTask.Assignee, parentTask.Supervisor]
      const renderToHtml = (element) =>
      require('react-dom/server').renderToString(element);
      await TaskService.SendAssignedNotification(zuidArr,allAppUsers,parentTask,lookUpDeal,"Task", renderToHtml(text)).then(e=>{
        AppReduxContextDispatch(setNotificationFlag(!getNotification));
      }).catch(e=>{})
  }
  async function handleSaveTask(data) {
    let user = JSON.parse(localStorage.getItem("userinfo"));
    const {
      TaskName,
      Priority,
      StartDate,
      DueDate,
      Assignee,
      Supervisor,
      PipelineROWID,
      TaskDescription,
      TimeEstimate,
      TaskStatus,
      TaskFlowId,
      TaskFlowObject,
      LookUpFields,
      InputFields,
      IsMilestone,
      Status_Time
    } = data;
    const payload = {
      TaskName,
      Priority,
      StartDate,
      DueDate,
      Assignee,
      Supervisor,
      PipelineROWID,
      TaskDescription,
      TimeEstimate,
      TaskStatus,
      TaskFlowId,
      TaskFlowObject,
      LookUpFields,
      InputFields,
      IsMilestone,
      Status_Time
    };
    if(!payload.TaskFlowId){
      let flowObj= allBlueprintsData?.filter(e=>e.DefaultFlow=="true")[0];
      payload.TaskFlowId =flowObj?.ROWID;
      payload.TaskFlowObject = flowObj;
    }
    payload["PipelineROWID"] = data.PipelineROWID;
    payload["Status_Time"] = taskModalState.action == "edit"? data?.TaskStatusDate : moment.utc().format('YYYY-MM-DD HH:mm:ss');
    if(!payload?.TaskName){
      swal('Alert','Task Name can not be empty!','warning');
      return
    }
    // let clientColor;
    // let dealColor;
    // if(lookUpDeal){
    //   clientColor=await TaskService.GetClientColor(lookUpDeal?.Account_Name.id);
    //   dealColor=await TaskService.GetDealColor(lookUpDeal?.Stage);
    // }
    let notifyArray= [payload?.Assignee, payload?.Supervisor];
    notifyArray = new Set(notifyArray);
    let notifyArraytoPass = [...notifyArray]; 

    if (taskModalState.action == "create") {
      payload["CREATEDBY"] = user.email_id;
      if (selectedTable == "tasks") {
        if (!isSubTaskView) {
          if(insertBelowData?.flag && !insertBelowData?.SubTask){
            payload['AddBelow'] = true;
            payload['Position'] = insertBelowData?.Position;
          }
          await AwsServerService.saveTask(payload)
            .then(async (res) => {
               if(payload['IsMilestone'] == 1){
                AwsServerService.updatePipeline({ROWID:data.PipelineROWID, IsMilestone:1})
              }
              setOpen(false);
              // send notification //
              let text = `<a style="color:#40a9ff" id="User-${userInfo?.email_id}">${
                userInfo?.first_name + " " + userInfo?.last_name
              }</a> <span> created task </span>
              <a style="color:#40a9ff" id="Task-${res[0]?.insertId}">${payload?.TaskName}</a>  
              in <a style="background-color:${clientColor}" id="Client-${lookUpDeal.Account_Name.id}">${lookUpDeal.Account_Name ? lookUpDeal.Account_Name.name : ""}
              </a>  <a style="background:${dealColor}" id="Deal-${lookUpDeal.id}">${lookUpDeal.Deal_Name}</a>`;
      
              await handleCreateNotification(notifyArraytoPass, AllUsers, "Task", text);
              // send notification //

              setTaskData({ ...taskEmptyTemplate });
              debugger
              await Promise.all(
                subTaskData.map((item) => {
                  if (item.SubTaskROWID || !item?.TaskName) {
                    return;
                  }
                  let flowObj= allBlueprintsData?.filter(e=>e.DefaultFlow=="true")[0];
                  item['TaskFlowObject']=flowObj;
                  item['TaskFlowId']=flowObj?.ROWID;
                  item["Status_Time"] = moment.utc().format('YYYY-MM-DD HH:mm:ss');
                  delete item["id"];
                  delete item["flag"];
                  delete item["PipelineROWID"];
                  item["TaskROWID"] = res[0]?.insertId;
                  notifyArraytoPass = [item.Assignee, item.Supervisor]
                  return AwsServerService.createSubtask(item).then((subtaskRes) => {
                    if(notifyArraytoPass){
                      let text = `<a style="color:#40a9ff" id="User-${userInfo?.email_id}">
                                    ${userInfo?.first_name + " " + userInfo?.last_name}
                                  </a> <span> created subtask </span>
                                  <a style="color:#40a9ff" id="Task-${subtaskRes[0]?.insertId}">
                                    ${item?.TaskName}
                                  </a>  
                                  in <a style="background-color:${clientColor}" id="Client-${lookUpDeal.Account_Name.id}">
                                    ${lookUpDeal.Account_Name ? lookUpDeal.Account_Name.name : ""}
                                  </a> 
                                  <a style="background:${dealColor}" id="Deal-${lookUpDeal.id}">
                                    ${lookUpDeal.Deal_Name}
                                  </a>`;
                
                      // Call notification API
                      return handleCreateNotification(notifyArraytoPass, AllUsers, "Task", text);
                    }
                    sendSubTaskNotification(item);
                  });
                })
              ).then((allRes) => {
                
              });
            })
            .catch((err) => { }).finally(e => {
              dispatch(Socket({ trigger: "refresh_activity", data: '' }))
            });
        } else {
          delete payload["PipelineROWID"];
          delete payload["IsMilestone"];
          if(!payload["TaskROWID"]){
            payload["TaskROWID"] = taskData.TaskROWID
          }
          await AwsServerService.createSubtask(payload)
            .then(async (res) => {
              if(insertBelowData?.SubTask){
                setOpen(false);
              }else{ 
              await AwsServerService.getTaskById(taskHistory[0]?.TaskId).then(res=>{
                let k=res[0]?.taskInfo;
                if(k){
                  handleHistoryAdd()
                  viewTaskFunction(k,"TASK");
                  // setLoader(false);
                  // setIsSubTaskView(true);
                }
              }).catch(e=>{
                // setLoader(false);
              })
              }
              let text = `<a style="color:#40a9ff" id="User-${userInfo?.email_id}">${
                userInfo?.first_name + " " + userInfo?.last_name
              }</a> <span> created sub-task </span>
              <a style="color:#40a9ff" id="Task-${res[0]?.insertId}">${payload?.TaskName}</a>  
              in <a style="background-color:${clientColor}" id="Client-${lookUpDeal.Account_Name.id}">${lookUpDeal.Account_Name ? lookUpDeal.Account_Name.name : ""}
              </a>  <a style="background:${dealColor}" id="Deal-${lookUpDeal.id}">${lookUpDeal.Deal_Name}</a>`;
      
              await handleCreateNotification(notifyArraytoPass, AllUsers, "Task", text);
              sendSubTaskNotification(payload)
            })
            .catch((err) => { }).finally(e => {
              dispatch(Socket({ trigger: "refresh_activity", data: '' }))
            });
        }
      } else {
        delete payload.Status_Time;
        if (!isSubTaskView) {
          await AwsServerService.saveTaskInTemplate(payload)
            .then(async (res) => { 
              if(payload['IsMilestone'] == 1){
                AwsServerService.updatePipelineInTemplate({ROWID:data.PipelineROWID, IsMilestone:1})
              }
              console.log("res", res);
              setOpen(false);
              await Promise.all(
                subTaskData.map((item) => {
                  if (item.SubTaskROWID || !item?.TaskName) {
                    return;
                  }
                  let flowObj= allBlueprintsData?.filter(e=>e.DefaultFlow=="true")[0];
                  item['TaskFlowObject']=flowObj;
                  item['TaskFlowId']=flowObj?.ROWID;
                  delete item["id"];
                  delete item["flag"];
                  delete item["PipelineROWID"];
                  delete item["TaskStatus"];
                  item["TaskROWID"] = res[0]?.insertId;
                  return AwsServerService.createSubtaskInTemplate(item);
                })
              ).then((allRes) => { 
                console.log("allRes", allRes);
              }); 
              // setPageRefreshData(!refreshData);
              setTaskData({ ...taskEmptyTemplate }); 
            })
            .catch((err) => {}).finally(e => {
              dispatch(Socket({ trigger: "refresh_activity", data: '' }))
            });;
        } else {
          delete payload["PipelineROWID"];
          delete payload["IsMilestone"];
          delete payload["TaskStatus"];
          payload["TaskROWID"] = taskData?.TaskROWID;
          await AwsServerService.createSubtaskInTemplate(payload)
            .then(async (res) => {
              await AwsServerService.getTaskByIdFromTemplate(taskHistory[0]?.TaskROWID).then(res=>{
                let k= res[0]?.taskInfo || res[0][0].taskInfo;
                if(k){
                  handleHistoryAdd()
                  viewTaskFunction(k,"TASK");
                  // setLoader(false);
                  // setIsSubTaskView(true);
                }
              }).catch(e=>{
                // setLoader(false);
              })
            })
            .catch((err) => {}).finally(e => {
              dispatch(Socket({ trigger: "refresh_activity", data: '' }))
            });;
        }
      }
    } else if (taskModalState.action == "edit") {
      if(canEdit == "NO") { 
        message.error("Permission Denied"); 
        return
      }      
      payload["MODIFIEDBY"] = user.email_id;
      payload["ROWID"] = isSubTaskView
        ? taskData?.SubTaskROWID
        : taskData?.TaskROWID;
      if(payload.Priority == "" || payload.Priority == null){
        payload["Priority"] = 'Not Set'
      }
      if (selectedTable == "tasks") {
        if (!isSubTaskView) {
          if(accessType=="read"){
            message.warning("Action not allowed. You have only read access.") 
            return;
          }
          if(canEdit == "NO") { 
            message.error("Permission Denied"); 
            return
          }
          await AwsServerService.updateTask(payload)
            .then(async (res) => { 
              setOpen(false);
              if(payload.TaskName !== originalTaskNameRef.current){
                let zuidArr = [];
                let text = '';
                  text = (
                    <>
                      changed Task Name from{' '}
                      <span style={{ fontWeight: 'bold' , whiteSpace:"nowrap"}}>
                        {originalTaskNameRef.current}
                      </span>{' '}
                      to{' '}
                    </>
                  );
                  zuidArr = [...zuidArr, payload.Assignee, payload.Supervisor]
                  const renderToHtml = (element) =>
                  require('react-dom/server').renderToString(element);
                  await TaskService.SendAssignedNotification(zuidArr,allAppUsers,payload,lookUpDeal,"Task", renderToHtml(text)).then(e=>{
                    AppReduxContextDispatch(setNotificationFlag(!getNotification));
                  }).catch(e=>{})
                  originalTaskNameRef.current = payload.TaskName;
                }
              await Promise.all(
                subTaskData.map((item) => {
                  if (item.SubTaskROWID || !item?.TaskName) {
                    return;
                  }
                  delete item["id"];
                  delete item["flag"];
                  delete item["PipelineROWID"];
                  item["TaskROWID"] = taskData?.TaskROWID;
                  notifyArraytoPass = [item.Assignee, item.Supervisor]
                  return AwsServerService.createSubtask(item).then((subtaskRes) => {
                    if(notifyArraytoPass){
                      let text = `<a style="color:#40a9ff" id="User-${userInfo?.email_id}">
                                    ${userInfo?.first_name + " " + userInfo?.last_name}
                                  </a> <span> created subtask </span>
                                  <a style="color:#40a9ff" id="Task-${subtaskRes[0]?.insertId}">
                                    ${item?.TaskName}
                                  </a>  
                                  in <a style="background-color:${clientColor}" id="Client-${lookUpDeal.Account_Name.id}">
                                    ${lookUpDeal.Account_Name ? lookUpDeal.Account_Name.name : ""}
                                  </a> 
                                  <a style="background:${dealColor}" id="Deal-${lookUpDeal.id}">
                                    ${lookUpDeal.Deal_Name}
                                  </a>`;
                
                      // Call notification API
                      return handleCreateNotification(notifyArraytoPass, AllUsers, "Task", text);
                    }
                    sendSubTaskNotification(item)
                  });
                })
              ).then((allRes) => {
                console.log("allRes", allRes);
              });
            })
            .catch((err) => {}).finally(e => {
              dispatch(Socket({ trigger: "refresh_activity", data: '' }))
            });;
        } else {
          delete payload["PipelineROWID"];
          delete payload["IsMilestone"];
          if(accessType=="read"){
            message.warning("Action not allowed. You have only read access.") 
            return;
          }
          await AwsServerService.updateSubtask(payload)
            .then(async (res) => {
              setOpen(false);
            })
            .catch((err) => {}).finally(e => {
              dispatch(Socket({ trigger: "refresh_activity", data: '' }))
            });;
        }
      } else {
        if (!isSubTaskView) {
          await AwsServerService.updateTaskInTemplate(payload)
            .then(async (res) => {
              setOpen(false);
              console.log("res", res);
              await Promise.all(
                subTaskData.map((item) => {
                  if (item.SubTaskROWID || !item?.TaskName) {
                    return;
                  }
                  delete item["id"];
                  delete item["flag"];
                  delete item["PipelineROWID"];
                  return AwsServerService.createSubtaskInTemplate(item);
                })
              ).then((allRes) => {
                console.log("allRes", allRes);
              });
              // setPageRefreshData(!refreshData);
              
            })
            .catch((err) => {}).finally(e => {
              dispatch(Socket({ trigger: "refresh_activity", data: '' }))
            });;
        } else {
          delete payload["PipelineROWID"];
          delete payload["IsMilestone"];
          await AwsServerService.updateSubtaskInTemplate(payload)
            .then(async (res) => { 
              setOpen(false);
            })
            .catch((err) => {}).finally(e => {
              dispatch(Socket({ trigger: "refresh_activity", data: '' }))
            });;
        }
      }
    } 
    setPageRefreshData(prev => !prev);
    setDependencyRefresh(prev => !prev);
    setTaskHistory([]);
    // setLookUpArray([])
    setIsSubTaskView(false);
  }  

  useEffect(e=>{
    if(taskModalState?.action == "create"){
      setSubTaskData([])
    }
  }, [taskModalState?.action])
  
  useEffect(
    (e) => {
      if (isSubTaskView) {
        setActiveTab("2");
      } else {
        setActiveTab(activeTab);
      }
    },
    [isSubTaskView]
  );

  useEffect(e=>{ 
    if(taskData && allDealsAndUsers && allDealsAndUsers.length>0){
      getBlueprintDataOptions(taskData, taskData.TaskStatus);
    }
  },[dealSelected]) 
  useEffect((e) => {
    if (viewTaskData && allDealsAndUsers && allDealsAndUsers.length > 0) {
      AppReduxContextDispatch(ResetInputFieldValidation());
      let newObject;
      let pipeline = viewTaskData.Pipeline;
      let task = viewTaskData.Task;
      let subtask = viewTaskData.SubTask;
      getAllDependenciesForTask(subtask?.hasOwnProperty('SubTaskROWID'), subtask?.hasOwnProperty('SubTaskROWID') ? subtask?.SubTaskROWID : task?.TaskROWID);

      let id = '';
      let param = '';
      id = subtask && subtask.SubTaskROWID ? subtask?.SubTaskROWID : task?.TaskROWID
      param = subtask && subtask.SubTaskROWID ? "SubTask" : "Task"

      if (subtask && subtask?.hasOwnProperty("SubTaskId")) {
        //subtask logic...
        let account;
        account = allDealsAndUsers?.filter(e => e.Deal_Name == pipeline?.DealName ? e?.Account_Name : '')

        newObject = { ...subtask, PipelineROWID: pipeline?.PipelineROWID }

        setDealSelected(pipeline?.DealName);
        setAccountSelected(account[0]?.Account_Name?.name)

        let array = [];
        array.push({
          value: pipeline?.PipelineROWID,
          label: pipeline?.PipelineName,
          key: pipeline?.PipelineROWID,
        });

        setAllPipelinesData(array);
        let blueprint;
        if (!newObject.TaskFlowObject) {
          blueprint = allBlueprintsData?.find(k => k.ROWID == newObject.TaskFlowId);
        } else {
          blueprint = newObject.TaskFlowObject;
        }
        if (blueprint) {
          // getDataForTaskAccess(blueprint.ROWID,newObject);
          getBlueprintDataOptions(newObject, newObject.TaskStatus);
        }
        newObject={...newObject,TaskFlowObject: blueprint}
        setTaskData(newObject);
        setSelectedBlueprintData({ ...selectedBlueprintData, data: blueprint });
        (newObject?.SubTasks && newObject.SubTasks.length > 0) ? setSubTaskData(newObject?.SubTasks) : setSubTaskData([]);
        // checkForCommentsForTask(id,param);
        clearInterval(clockInterval.current);
          
        setTimer(0);
        setStartTimer(false);
        setTimer2(0);
        setTimer3(0);
        checkForActiveTrackingSessions();
        let type = newObject.hasOwnProperty('SubTaskROWID') ? 'SubTasks' : 'Tasks';
        if (type == 'Tasks') {
          checkRecordIfAvailable(newObject.TaskROWID, type)
          setTypeOfTask({ ROWID: newObject.TaskROWID, Type: type });
          setIsSubTaskView(false);
        } else {
          checkRecordIfAvailable(newObject.SubTaskROWID, type)
          setTypeOfTask({ ROWID: newObject.SubTaskROWID, Type: type });
          setIsSubTaskView(true);
        }
      } else if (task && task?.hasOwnProperty("TaskId")) {
        //task logic...
        let account;
        account = allDealsAndUsers?.filter(e => e.Deal_Name == pipeline?.DealName ? e?.Account_Name : '')
        setDealSelected(pipeline?.DealName);
        setAccountSelected(account[0]?.Account_Name?.name)

        let array = [];
        array.push({
          value: pipeline?.PipelineROWID,
          label: pipeline?.PipelineName,
          key: pipeline?.PipelineROWID,
        });

        setAllPipelinesData(array);
        let blueprint;
        if (!task.TaskFlowObject) {
          blueprint = allBlueprintsData?.find(k => k.ROWID == task.TaskFlowId);
        } else {
          blueprint = task.TaskFlowObject;
        }
        if (blueprint) {
          // getDataForTaskAccess(blueprint.ROWID,task);
          getBlueprintDataOptions(task, task.TaskStatus);
        }
        task={...task,TaskFlowObject: blueprint};
        setTaskData(task);
        setSelectedBlueprintData({ ...selectedBlueprintData, data: blueprint });
        (task?.SubTasks && task.SubTasks.length > 0) ? setSubTaskData(task?.SubTasks) : setSubTaskData([]);
        // checkForCommentsForTask(id,param);
        clearInterval(clockInterval.current);
          
        setTimer(0);
        setStartTimer(false);
        setTimer2(0);
        setTimer3(0);
        checkForActiveTrackingSessions();
        let type = task.hasOwnProperty('SubTaskROWID') ? 'SubTasks' : 'Tasks';
        if (type == 'Tasks') {
          checkRecordIfAvailable(task.TaskROWID, type)
          setTypeOfTask({ ROWID: task.TaskROWID, Type: type });
        } else {
          checkRecordIfAvailable(task.SubTaskROWID, type)
          setTypeOfTask({ ROWID: task.SubTaskROWID, Type: type });
        }
      }
    } else {
      AppReduxContextDispatch(ResetInputFieldValidation());
      let obj = {...taskEmptyTemplate};
      let flowObj= allBlueprintsData?.filter(e=>e.DefaultFlow=="true")[0]; 
      if (flowObj) {
       obj["TaskFlowId"] = flowObj?.ROWID;
       obj['TaskFlowObject']=flowObj;
      }
      setTaskData(obj);
      setAllPipelinesData([]);
      setSubTaskData([])
      setDealSelected();
      setAccountSelected();
      clearInterval(clockInterval.current);
      setTimer(0);
      setStartTimer(false);
      setTimer2(0);
      setTimer3(0);
      setAnotherSessionActiveFlag({ Active: false, Record: {} })
      setUserList([]);
      setDescription('');
      setTypeOfTask({ ROWID: '', Type: '' });
      setSelectedDependenciesCache({ WaitingOn: [], Blocking: [] })
      setDropdownCount({ WaitingOn: 0, Blocking: 0 })
    }
  },
    [viewTaskData, dependencyRefresh,allDealsAndUsers, allPipelineData]
  );

    useEffect(()=>{ 
    if(selectedTable=='pipelines'){ 
     setFilteredDropdownTasksData(dropdownTasksDataCache);
    }
    },[selectedTable,dropdownTasksDataCache])
 
  const saveCommentForTask= async ()=>{ 
    let sourceTaskType=taskData?.hasOwnProperty('SubTaskROWID')?"SubTask":"Task";
    let sourceId=taskData?.hasOwnProperty('SubTaskROWID')?taskData?.SubTaskROWID:taskData?.TaskROWID; 
    if(taskData['Comment']){
     let commentPayload = {
       "Message" : taskData['Comment'],
       "CREATEDBY" : userInfo.email_id,
       "TaskId" : sourceId,
       "TaskType" : sourceTaskType
     } 
     await AwsServerService.addComment(commentPayload).then(r=>{
       let message=`USER added comment " ${taskData["Comment"]} "`
       handleCreateActivity('COMMENT',sourceTaskType=='Task'?'Tasks':'SubTasks',message,sourceId,selectedTable=='pipelines');
       setTaskData({...taskData,'Comment':''});
      }).catch(e=>{
       console.log("error in comment", e);                  
     })  
    }
  }
  function getOptionsForDropdown(data,selected){
    let options=[];
    let selectedData={...selected}
    let type=taskData?.hasOwnProperty('SubTaskROWID')?'SubTasks':'Tasks';
    let id=taskData?.hasOwnProperty('SubTaskROWID')?taskData?.SubTaskROWID:taskData?.TaskROWID;
    const valuesToExclude = new Set([
      ...selectedData.Blocking.map(item => item.value),
      ...selectedData.WaitingOn.map(item => item.value),
      `${type}_${id}`
    ])  
    data.filter(e=>!valuesToExclude.has(e.value)?options.push(e):'')
    return options;
  }
  // console.log("statusOptions", statusOptions)
  const getBlueprintDataOptions = async (data,status)=>{
    if(data){
    let currentStatus=status; 
    let node =  data?.TaskFlowObject?.Nodes?.filter(e=>e.id==currentStatus)[0];
    let Edges = data?.TaskFlowObject?.Edges?.filter(e=>!e?.data?.visited && e.source==node?.id); 
    let options = [];
    let optionsStatus = [];
      Edges?.map((item) => {
        let isValid = evaluateEdgeVisibility({ 
          Project: allDealsAndUsers?.find(d=>d.Deal_Name==dealSelected), 
          Task: {...taskData},
          "Input Fields": taskData?.TaskFlowObject?.InputFields
        }, item, data.TaskFlowObject?.Edges,AppReduxContext,AppReduxContextDispatch)
          if (item.label) {
            let temp = {
              value: item?.label,
              label: item?.label,
              key: item?.id,
              Criteria:item.Criteria,
              disable: !isValid,
            }
            if (item?.data?.color) {
              temp["color"] = item?.data?.color
            }
            options.push(temp);
          }
      });
      data?.TaskFlowObject?.Nodes?.map((item) => {
      if(item.data?.label && item.type=="custom"){
        let temp={
          value: item?.data?.label,
          label: item?.data?.label,
          key: item?.id,
        }
        if(item.data?.color){
          temp["color"]=item.data.color == "grey" ? "#808080" : item.data.color
        }
        optionsStatus.push(temp);
      }
      }) 
      setMainStatusOptions(optionsStatus);
      console.log("statusOptions", options,optionsStatus);
      
      setStatusOptions(options) 
  } 
    }
    const modifyDependenciesData=(result,sourceTaskType,ROWID)=>{
      let obj = {
        WaitingOn: [],
        Blocking: []
      }; 
      let allDep=[];
      result.forEach(element=>{
        let waitingObj={};
        let blockingObj={};
        let t={...element}
        if(sourceTaskType==element.STaskType && ROWID==element.SourceTaskId){
          if(element.DependancyType=='WaitingOn'){ 
            waitingObj['ROWID']=element.ROWID
            waitingObj['DependancyType']=element.DependancyType
            waitingObj['CREATEDBY']=element.CREATEDBY
            waitingObj['MODIFIEDBY']=element.MODIFIEDBY
            waitingObj['IsResolved']=element.IsResolved
            waitingObj['SourceDependencyStatus']=element.SourceDependencyStatus
            waitingObj['TargetDependencyStatus']=element.TargetDependencyStatus
            waitingObj['sourceValue']=`${element.STaskType}_${element.SourceTaskId}`
            waitingObj['value']=`${element.TaskType}_${element.TargetTaskId}`
            obj.WaitingOn.push(waitingObj);
          }else{ 
            blockingObj['ROWID']=element.ROWID
            blockingObj['DependancyType']=element.DependancyType
            blockingObj['CREATEDBY']=element.CREATEDBY
            blockingObj['MODIFIEDBY']=element.MODIFIEDBY
            blockingObj['IsResolved']=element.IsResolved
            blockingObj['SourceDependencyStatus']=element.SourceDependencyStatus
            blockingObj['TargetDependencyStatus']=element.TargetDependencyStatus
            blockingObj['sourceValue']=`${element.STaskType}_${element.SourceTaskId}`
            blockingObj['value']=`${element.TaskType}_${element.TargetTaskId}`
            obj.Blocking.push(blockingObj);
          }
        }
        t["SourceTaskId"] = t["STaskType"] + "_" + t["SourceTaskId"]
        t["TargetTaskId"] = t["TaskType"] + "_" + t["TargetTaskId"]
        allDep.push(t);
      })
      setAllDependencies(allDep);
      return obj;
    }
    const getAllDependenciesForTask = (subtask,ROWID) => { 
      if(ROWID==undefined||ROWID==null){
        return
      }

      let sourceTaskType=subtask?'SubTasks':'Tasks';
      if(selectedTable=='pipelines'){
        AwsServerService.getAllTempDependencies().then(r => {
          const result = r.data;
          if (result.length > 0) {
            let obj = modifyDependenciesData(result, sourceTaskType, ROWID);
            setSelectedDependenciesCache(obj);
          } else {
            setSelectedDependenciesCache({ WaitingOn: [], Blocking: [] });
            setAllDependencies([]);
          }
        });
      }else{
        AwsServerService.getAllDependencies().then(res => {
          const result = res.data;
          if (result.length > 0) {
            let obj = modifyDependenciesData(result, sourceTaskType, ROWID);
            setSelectedDependenciesCache(obj);
          } else {
            setSelectedDependenciesCache({ WaitingOn: [], Blocking: [] });
            setAllDependencies([]);
          }
        })
      
    }
  };
  
  useEffect(() => {
    let data = { ...selectedDependenciesCache }
    setSelectedDependencies(data);
  }, [selectedDependenciesCache])

  useEffect(() => {
    if (allAccounts) {
      let array = [];
      const filteredAccounts = allAccounts.filter((item) => item?.Account_Name !== "All");
      filteredAccounts.forEach((item) => {
        array.push({
          value: item?.Account_Name,
          label: item?.Account_Name,
          key: item?.id,
        });
      });
      array.unshift({
        value: "Miscellaneous",
        label: "Miscellaneous",
        key: "Miscellaneous",
      });
  
      setAllAccountsData(array);
    }
  }, [allAccounts]);
  

  useEffect(
    (e) => {
      let array = [];
      allDealsAndUsers = allDealsAndUsers?.filter(
        (item) =>
          item.hasOwnProperty("Created_Time") &&
          item?.Account_Name?.name == accountSelected
      );
      allDealsAndUsers?.map((item) => {
        array.push({
          value: item?.Deal_Name,
          label: item?.Deal_Name,
          key: item?.id,
        });
      });
      setAllDealsData(array);
    },
    [accountSelected]
  );

  useEffect(() => {
    if (dealSelected) {
      AwsServerService.getPipelineDataByDeal(dealSelected)
        .then((res) => {
          let array = [];
          res?.map((item) => {
            array.push({
              value: item?.PipelineROWID,
              label: item?.PipelineName,
              key: item?.PipelineROWID,
            });
          });
          setAllPipelinesData(array);
          let data=res;
          let result =[]; 
          if (data) {
            for (let i = 0; i < data.length; i++) {
              let pipeline = data[i];
              if (pipeline.Tasks) {
                for (let j = 0; j < pipeline.Tasks.length; j++) {
                  let task = pipeline.Tasks[j];
                  let statusColor = "#808080";  
                  if (task?.TaskFlowObject) {
                    let filterData = task?.TaskFlowObject.Nodes.find(e => e.data.label == task.TaskStatus);
                    statusColor = filterData && filterData?.data?.color ? filterData.data.color : statusColor;
                  } 
                  let tempStatus=task?.TaskFlowObject?.Nodes?.find(k=>k.id==task.TaskStatus);
                   
                  result.push({
                    label: task?.TaskName,
                    value: `Tasks_${task?.TaskROWID}`,
                    status:tempStatus?.data?.label,
                    TaskStatus: task?.TaskStatus,
                    statusColor: tempStatus?.data?.color,
                    taskData: task
                  }); 
                  if (task.SubTasks) {
                    for (let k = 0; k < task.SubTasks.length; k++) {
                      let subtask = task.SubTasks[k];
                      if (subtask?.TaskFlowObject) {
                        let filterData = subtask?.TaskFlowObject.Nodes.find(e => e.data.label == subtask.TaskStatus);
                        statusColor = filterData && filterData?.data?.color ? filterData.data.color : statusColor;
                      } 
                      let tempStatus1=subtask?.TaskFlowObject?.Nodes?.find(k=>k.id==subtask.TaskStatus);
                      result.push({
                        label: subtask?.TaskName,
                        value: `SubTasks_${subtask?.SubTaskROWID}`,
                        status: tempStatus1?.data?.label,
                        TaskStatus: subtask?.TaskStatus,
                        statusColor: tempStatus1?.data?.color,
                        taskData: subtask
                      });
                    } } } } } } 
                  setFilteredDropdownTasksData(result);
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      setAllPipelinesData([]);
    }
  }, [dealSelected]);

  useEffect(() => {
    if (viewPipelineData && viewPipelineData?.length > 0) {
      let temp = { ...taskData };
      temp["PipelineROWID"] = viewPipelineData[0]?.PipelineROWID || viewPipelineData[0]?.ROWID;
      setTaskData(temp);
      let array = [];
      array.push({
        value: viewPipelineData[0]?.PipelineROWID || viewPipelineData[0]?.ROWID,
        label: viewPipelineData[0]?.PipelineName,
        key: viewPipelineData[0]?.PipelineROWID || viewPipelineData[0]?.ROWID,
      });
      setAllPipelinesData(array);
    } else {
      setAllPipelinesData([]);
    }
  }, [viewPipelineData]);
    
   
  const activitySections = [
    {
      key: "Activity",
      open: localStorage.getItem("CommentId") ? false : true,
      icon: <FontAwesomeIcon icon={faCommentAlt} />,
      component: (taskId, flag, flag2, allTasksAndSubtasks,task) => {
        // let module=flag2? flag ? "SUBTASKTEMPLATE" :"TASKTEMPLATE"
          
        return (
          <ActivitySection task={task} taskId={taskId} module={(flag2 && flag) ? "SUBTASKTEMPLATE" :
            (flag2 && !flag) ? "TASKTEMPLATE" :
            (!flag2 && flag) ? "SUBTASK" : "TASK"} 
            // refreshData={refreshData}
            // allTasksAndSubtasks={allTasksAndSubtasks}
            // viewTaskFunction={openTaskFromActivity}
            // selectedActivityFilter={selectedActivityFilter}
            // activityFilter={activityFilter}
            />
        );
      },
    },
    selectedTable === "tasks" && {
      key : "Comments",
      open: localStorage.getItem("CommentId") ? true : false,
      icon:<FontAwesomeIcon icon={faComments}/>,
      component :(task)=>{
      return <TaskCommentSection 
                taskId={isSubTaskView ? taskData?.SubTaskROWID : taskData?.TaskROWID}
                taskType={isSubTaskView ?'SubTask':'Task'}
                taskData={taskData}
                taskDataId = {viewTaskData?.Task?.TaskId}
                setTaskData={setTaskData}
                createTaskModal={true}
              />
      }
    },
    selectedTable === "tasks" && {
      key: "Timeline",
      open: false,
      icon: <img src={StatusTimelineIcon} style={{width:"17px"}}/>,
      component: (taskId, flag, flag2, allTasksAndSubtasks,task,refresh) => {
        // let module=flag2? flag ? "SUBTASKTEMPLATE" :"TASKTEMPLATE"
        return <StatusTimeline task={task} refresh={refresh} />
      },
    }, 
    selectedTable === "tasks" && {
      key : "Reminder",
      open: false,
      icon:<svg 
          fill="#5a6c97"  
          viewBox="0 0 52 52" 
          xmlns="http://www.w3.org/2000/svg"
          className="reminder-icon"
          style={{ width: "17px" }}  
        >
          <path d="M50.3,7.5a7.45,7.45,0,0,0-6.2-5.9,7.81,7.81,0,0,0-5.8,1.6.81.81,0,0,0,.2,1.4,28.48,28.48,0,0,1,9.4,8.2.84.84,0,0,0,1.4,0A6.87,6.87,0,0,0,50.3,7.5ZM13.5,4.7a.9.9,0,0,0,.2-1.4A7,7,0,0,0,7.9,1.7,7.23,7.23,0,0,0,1.7,7.5a7.36,7.36,0,0,0,1.1,5.3.84.84,0,0,0,1.4,0A26,26,0,0,1,13.5,4.7ZM26,6.5a22.06,22.06,0,0,0-22,22,21.58,21.58,0,0,0,4.3,13L5,44.8a3.2,3.2,0,0,0,0,4.6,3.15,3.15,0,0,0,4.6,0l3.3-3.3A22.1,22.1,0,0,0,26,50.4a21.58,21.58,0,0,0,13-4.3l3.3,3.3a3.25,3.25,0,0,0,2.4,1A3.3,3.3,0,0,0,47,44.8l-3.3-3.3a21.58,21.58,0,0,0,4.3-13A21.94,21.94,0,0,0,26,6.5ZM10.5,28.4A15.5,15.5,0,1,1,26,43.9,15.49,15.49,0,0,1,10.5,28.4Zm18-.9V21.1a2.37,2.37,0,0,0-2.4-2.4,2.43,2.43,0,0,0-2.4,2.4v7.3a2.06,2.06,0,0,0,.7,1.7l5.7,5.7a2.41,2.41,0,0,0,3.4,0,2.3,2.3,0,0,0,0-3.4Z"></path>
        </svg>,
      component :(task)=>{
        return <ReminderForTasks taskData={taskData} allUsers={AllUsers}/>
      }
    },
    selectedTable === "tasks" && {
      key : "Emails",
      open: false,
      icon:<FontAwesomeIcon icon={faEnvelope}/>,
      component :(task)=>{
      let type=taskData?.SubTaskROWID?'SubTask':'Task';
      let rowID=taskData?.SubTaskROWID?taskData?.SubTaskROWID:taskData?.TaskROWID;
      return <EmailChatSection getParams={getParams} location={location} taskROWID={rowID} taskType={type}
      clickedFromBody={false} 
        handleNotificationHyperlink={handleNotificationHyperlink}
        allTask={taskData}
        viewTaskData={viewTaskData}
        allUsers={AllUsers}
        cacheDeals={AllDeals} 
        dealObj={lookUpDeal}
        fromtask={true}
      /> 
      }
    },
  ];

  // Function to handle option selection

  const [sidebarOptions, setSidebarOptions] = useState([...activitySections]);
  const [activitySection, setActivitySection] = useState(localStorage.getItem("CommentId") ? 1 : 0);
  const [selectionRange, setSelectionRange] = useState([moment(new Date()),moment(new Date())]);

  const getDates = (arr) =>{
    let temp = [];
    if(arr[0] && (dayjs(arr[0]))?.isValid()){
      temp.push(dayjs(arr[0]))
    }else{
      temp.push(dayjs(new Date()))
    }
    if(arr[1] && (dayjs(arr[1]))?.isValid()){
      temp.push(dayjs(arr[1]))
    }else{
      temp.push(dayjs(new Date()))
    }
    return temp
  }
  const disabledDate = (current) => {
    // Disable dates before today for the end date
    return current && current < moment().startOf('day');
  };
  const changeDateRange = (item) => { 
    if(accessType=="read"||accessType=='none'){
    message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
    return;
    }
    // Update the selection range
    // 
    // if(dayjs(item[1].$d).isBefore(item[0].$d)){
    //   return;
    // }
    let temp = { ...taskData };
    temp["StartDate"] = item[0].$d;
    temp["DueDate"] = item[1].$d;
    setSelectionRange(item)
    if(taskModalState.action == "edit"){
      updateTaskData({...taskData},null,null,{ "StartDate":temp.StartDate,"DueDate":temp.DueDate})
    }
    setTaskData(temp);
  };
  useEffect(e=>{
    if(statusOptions){
      let modifiedEdgesAndNodes=modifyEdgesAndNodes(taskData?.TaskFlowObject?.Edges,taskData?.TaskFlowObject?.Nodes,statusOptions.map(k=>k.key))
      let obj={...taskData};
      if(modifiedEdgesAndNodes && modifiedEdgesAndNodes.updatedNodes && modifiedEdgesAndNodes.updatedEdges){
        obj={
          ...obj,Nodes:modifiedEdgesAndNodes.updatedNodes,Edges:modifiedEdgesAndNodes.updatedEdges
        }
      }
      setTaskData(obj)
    }
  },[statusOptions])
  // console.log('filtered',filteredDropdownTasksData,selectedDependencies.WaitingOn);

  const [waitingPopupFlag,setWaitingPopupFlag]=useState({records:[],flag:false,taskStatus:''});
  // console.log('filtered',filteredDropdownTasksData,selectedDependencies.WaitingOn);
  const customePopup=()=>{
    return (<NewCustomePopover
      width={30}
      open={waitingPopupFlag.flag}
      title={"Warning!"}
      okText={"OK"}
      cancelText={"Cancel"}
      cancelButtonProps={{ style: { display: 'none' } }}
      onCancel={e=>{ 
        setWaitingPopupFlag(prev=>({...prev,flag:false}))
      }}
      onOk={e=>{
        setWaitingPopupFlag(prev=>({...prev,flag:false})) 
      }}
      fromDependency={true}
    >
      <div className="depClasspopup"> 
          <div>
        {/* <span style={{padding: '0px 6px',borderRadius: '28px',
          background:taskData?.TaskFlowObject?.Nodes?.find(k=>k.id==waitingPopupFlag.taskStatus)?.data?.color||'lightgray',color:invertColor(taskData?.TaskFlowObject?.Nodes?.find(k=>k.id==waitingPopupFlag.taskStatus)?.data?.color,true)}}>
             {taskData?.TaskFlowObject?.Nodes?.find(k=>k.id==waitingPopupFlag.taskStatus)?.data?.label} 
        </span> */}
         {waitingPopupFlag.taskStatus}
        </div>
        <div>
          {
            waitingPopupFlag.records.map((res,index)=> ( 
               <div>
                <span>{index+1}. </span>
                <span style={{
                  padding: '0px 6px', borderRadius: '28px',
                  background: res?.record?.taskData?.TaskFlowObject?.Nodes?.find(k => k.id == res?.depRecord?.TargetDependencyStatus)?.data?.color || 'lightgray',
                  color: invertColor(res?.record?.taskData?.TaskFlowObject?.Nodes?.find(k => k.id == res?.depRecord?.TargetDependencyStatus)?.data?.color, true)
                }}>
                  {res?.TargetDependencyStatus=="S"?"Start":"Finish"}</span>
                <span> of {filteredDropdownTasksData?.find(r=>r.value==res.value)?.label}</span>
               </div>  
              ) )
          }
          </div> 
      </div>
    </NewCustomePopover>)
  }
  
  const getDependancyValidArrr = (thisTaskData, thisTaskOldStatus, waitingOnDep) => {
    let pendingDep = [];
    if (waitingOnDep?.length > 0 && thisTaskOldStatus == "S") {
      waitingOnDep = waitingOnDep.filter(d => d.SourceDependencyStatus.startsWith("S"));
    } else if (waitingOnDep?.length > 0 && thisTaskOldStatus == "F") {
      waitingOnDep = waitingOnDep.filter(d => d.SourceDependencyStatus.startsWith("F"));
    }
    if (waitingOnDep?.length > 0) {
      waitingOnDep.filter(d => {
        if (d.IsResolved != "1") {
          pendingDep.push(d);
        }
      })
    }
    return pendingDep;
  }

  const updateBlockings = (deps) =>{
    Promise.all(
      deps.map((item) => {
        let [type, id] = item.value.split('_');
        let [types, ids] = item.sourceValue.split('_');
        let payload = {
          TASKID: id,
          TASKTYPE: type,
          TASKDEPTYPE: 'Blocking',
          TASKSTATUS: item.SourceDependencyStatus,
          REVDEPTASKTYPE: 'WaitingOn',
          TARGETTASKSTATUS: item.TargetDependencyStatus,
          TARGETTYPE:types,
          TARGETID:ids
        }
        return AwsServerService.updateIsResolvedInDependency(payload).then(res =>res);
      })
    ).then((resolve) => {
      console.log(resolve);
      getAllDependenciesForTask(viewTaskData?.SubTask?.hasOwnProperty('SubTaskROWID'), viewTaskData?.SubTask?.hasOwnProperty('SubTaskROWID') ? viewTaskData?.SubTask?.SubTaskROWID : viewTaskData.Task?.TaskROWID)
    })
  }
  const handleDependencyAfterFlowChange = (data, taskdata) => { 
    let currentStatusOfSourceTask = taskdata?.TaskFlowObject?.Nodes?.find(k => k.id == taskdata.TaskStatus);
    Promise.all(
      Object.keys(data).map(deptype => {   
        return data[deptype].map(record => {  
          let [types, id] = record.value.split('_');
          let [stype, sId] = record.sourceValue.split('_');
          let isResolvedDependancy = 0;
          let task=allTasksAndSubtasks[types]?.get(Number(id));
          let currentStatusOfTargetTask = task?.TaskFlowObject?.Nodes?.find(k => k.id == task?.TaskStatus);
          let tempTaskS;
          let tempTaskState;
          let tempTaskSAlt;
          let tempTaskStateAlt; 
          if (deptype == "WaitingOn") {
            tempTaskS = record.TargetDependencyStatus;
            tempTaskState = currentStatusOfTargetTask?.data?.state;
            tempTaskSAlt = record.SourceDependencyStatus;
            tempTaskStateAlt = currentStatusOfSourceTask?.data?.state;
          } else {
            tempTaskS = record.SourceDependencyStatus;
            tempTaskState = currentStatusOfSourceTask?.data?.state;
            tempTaskSAlt = record.TargetDependencyStatus;
            tempTaskStateAlt = currentStatusOfTargetTask?.data?.state;
          } 
          if ((tempTaskS == "S" && tempTaskState != "Start") || (tempTaskSAlt == "S" && tempTaskStateAlt != "Start")) {
            isResolvedDependancy = 1;
          } else if ((tempTaskS == "F" && tempTaskState == "Close") || (tempTaskSAlt == "F" && tempTaskStateAlt == "Close")) {
            isResolvedDependancy = 1;
          }  
          let payload = {
            TargetTaskId: id,
            TaskType: types,
            TargetDependencyStatus: record.TargetDependencyStatus,
            IsResolved:isResolvedDependancy,
            SourceDependencyStatus: record.SourceDependencyStatus,
            MODIFIEDBY: localStorage.getItem("ZUID"),
            ROWID: record.ROWID
          }
          return AwsServerService.updateDependency(payload,).then(async () => {
            let typeOfDep = deptype == 'Blocking' ? 'WaitingOn' : 'Blocking';
            let reversePayoad = {
              STaskType: types,
              SourceTaskId: id,
              TargetDependencyStatus: record.SourceDependencyStatus,
              SourceDependencyStatus: record.TargetDependencyStatus,
              targetStatus:record.SourceDependencyStatus,
              sourceStatus:record.TargetDependencyStatus,
              DependancyType: typeOfDep,
              sourceType: stype,
              sourceId: sId,
              IsResolved:isResolvedDependancy, 
              MODIFIEDBY: localStorage.getItem("ZUID"), 
            }
            await AwsServerService.updateDependencyReverse(reversePayoad);
          });
        });
      })
    ).then(res => {
      getAllDependenciesForTask(
        taskData?.hasOwnProperty('SubTaskROWID'),
        taskData?.hasOwnProperty('SubTaskROWID') ? taskData?.SubTaskROWID : taskData?.TaskROWID
      );
    }).catch(err => {
      console.error("Error updating dependencies:", err);
    });
  };
  
  const reopenDependancies = (deps) =>{
    Promise.all(
      deps.map((item) => {
        let [type, id] = item.value.split('_');
        let payload = {
          TASKID: id,
          TASKTYPE: type,
          TASKDEPTYPE: 'Blocking',
          TASKSTATUS: item.SourceDependencyStatus,
          REVDEPTASKTYPE: 'WaitingOn'
        }
        return AwsServerService.reopenResolvedDependency(payload).then(res =>res);
      })
    ).then((resolve) => {
      console.log(resolve);
      getAllDependenciesForTask(viewTaskData?.SubTask?.hasOwnProperty('SubTaskROWID'), viewTaskData?.SubTask?.hasOwnProperty('SubTaskROWID') ? viewTaskData?.SubTask?.SubTaskROWID : viewTaskData.Task?.TaskROWID)
    })
  } 
  const modifySubjectIfApplicable = (data) =>{
    let subject="";
    if(data){
      let parts = data.split(/(\{.*?\})/);
      parts = parts.filter(part => part !== "")
      for(const str of parts){
          if(str.includes("{") && str.includes("}")){
            let field=str.replace("{","").replace("}","");
              if(field=='Task_Name'){
                subject += taskData['TaskName'];
              }else if(field=='Assignee' || field=='Supervisor'){
                subject += userOptions?.find(el=>el.value==taskData[field])?.label;
              }else{
                if(field=="Project_Status"){
                  subject += lookUpDeal['Stage'];
                }else if(field=="Account_Name"){
                  subject += lookUpDeal[field]?.name;
                }else{
                  subject += lookUpDeal[field];
                }
              }
          }else{
              subject += str;
          }
      }
    }
    return subject;
  } 
  const getAccountMailIds = (data,type) => { 
    if(data && data.length==0){
      return "";
    }
    let emailId=[];
    const contacts = Object.values(moduleContacts || {}).flat();
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      let value = element[type];
      if(element.AttendeeType == 'Role'){
        let user=allCacheRoles?.find(e=>e.ROWID==value); 
        if(user?.RoleType=='Deal'){
          let userId=allCacheUserRoles?.find(el=>el.RoleId==value && el.ProjectId==dealSelected)?.UserId;
          userId = contacts?.find(k => k.id == userId)?.Email
          emailId.push(userId);
        }else if(user?.RoleType == 'Account'){ 
          let userId=allCacheUserRoles?.find(el=>el.RoleId==value && el.ProjectId==lookUpDeal?.Account_Name?.id)?.UserId;
          userId = contacts?.find(k => k.id == userId)?.Email
          emailId.push(userId);
        }else if(user?.RoleType == 'Zoho'){
          let mail = AllUsers?.find(e=>e.zuid == value)?.email;
          emailId.push(mail);
        }else if(user?.RoleType == 'Vendor'){
          let userId=allCacheUserRoles?.find(el=>el.RoleId==value && el.ProjectId==dealSelected)?.UserId;
          let mailId = contacts?.find(k => k.id == userId)?.Email
          emailId.push(mailId);
        } 
      }else if( element.AttendeeType == "Zoho"){
        let mail = AllUsers?.find(e=>e.zuid == value)?.email;
        emailId.push(mail);
      }else if(element.AttendeeType == "Account"){
        let mailId = contacts?.find(k => k.id == value)?.Email
        emailId.push(mailId);
      }else if(element.AttendeeType == "Vendor"){
        let mailId = contacts?.find(k => k.id == value)?.Email
        emailId.push(mailId);
      }
    }
    return emailId.join(", ");
  }
  
  const resolveAssigneeOrSupervisor = (value, fieldName) => {
    const isZuid = AllUsers?.find(user => user.zuid == value);
    if (isZuid) {
      return value;
    }
    const contacts = Object.values(moduleContacts || {}).flat();
    let user = allCacheRoles?.find(e => e.ROWID == value);
    let email = null;
    
    if (!user) {
      email = AllUsers?.find(e => e.zuid == value)?.email;
      if (email) {
        const foundUser = AllUsers?.find(u => u.email === email);
        return foundUser?.zuid || value;
      }
      return value;
    }
    if (user?.RoleType === 'Deal') {
      let userId = allCacheUserRoles?.find(el => el.RoleId == value && el.ProjectId == dealSelected)?.UserId;
      email = contacts?.find(k => k.id == userId)?.Email;
    } else if (user?.RoleType === 'Account') {
      let userId = allCacheUserRoles?.find(el => el.RoleId == value && el.ProjectId == lookUpDeal?.Account_Name?.id)?.UserId;
      email = contacts?.find(k => k.id == userId)?.Email;
    } else if (user?.RoleType === 'Zoho') {
      let zuid = AllUsers?.find(e => e.zuid == value)?.zuid;
      return zuid || value;
    } else if (user?.RoleType === 'Vendor') {
      let userId = allCacheUserRoles?.find(el => el.RoleId == value && el.ProjectId == dealSelected)?.UserId;
      email = contacts?.find(k => k.id == userId)?.Email;
    }
    if (email) {
      const foundUser = AllUsers?.find(u => u.email === email);
      return foundUser?.zuid || value;
    }
    return value;
  }
  
  function extractEmails(emailObjects) {
    let emailAddresses = new Set();
    emailObjects.forEach(email => {
      if (email.toAddress) {
        email.toAddress.split(',').forEach(address => emailAddresses.add(address.trim()));
      }
      if (email.ccAddress) {
        email.ccAddress.split(',').forEach(address => emailAddresses.add(address.trim()));
      }
      if (email.bccAddress) {
        email.bccAddress.split(',').forEach(address => emailAddresses.add(address.trim()));
      }
    });
    return Array.from(emailAddresses).map(address => `"${address}"`).join(', ');
  }
  const checkRemindersForTaskFlow = ({TaskFlowId,NodeId,NextNode,PrevNode}) =>{
    
    let OSE = taskFLowReminders?.filter(r=>TaskFlowId == r.TaskFlowId && r.TriggerType=="OSE" && NextNode.id==r.Status);
    let OSC = taskFLowReminders?.filter(r=>TaskFlowId == r.TaskFlowId && r.TriggerType=="OSC" && PrevNode.id==r.Status);
    let LT = taskFLowReminders?.filter(r=>TaskFlowId == r.TaskFlowId && r.TriggerType=="LT" && NextNode.id==r.Status);
    console.log(taskFLowReminders);
    if(OSE.length>0){
      OSE.forEach(r=>{
        checkReminder({
          data:r,
          ModuleUsers:moduleContacts,
          ZohoUsers:state.AllAppUsers,
          type:"OSE",
          Roles:allCacheRoles,
          lookUpDeal:lookUpDeal,
          UserRoles:allCacheUserRoles,
        })
      })
    }
    if(OSC.length>0){
      OSC.forEach(r=>{
        checkReminder({
          data:r,
          ModuleUsers:moduleContacts,
          ZohoUsers:state.AllAppUsers,
          type:"OSC",
          Roles:allCacheRoles,
          lookUpDeal:lookUpDeal,
          UserRoles:allCacheUserRoles,
        })
        // checkReminder({data:r,ModuleUsers:moduleContacts,ZohoUsers:state.AllAppUsers,type:"OSC"})
      })
    }
    if(LT.length>0){
      LT.forEach(r=>{
        checkReminder({
          data:r,
          ModuleUsers:moduleContacts,
          ZohoUsers:state.AllAppUsers,
          Roles:allCacheRoles,
          lookUpDeal:lookUpDeal,
          UserRoles:allCacheUserRoles,
        })
      })
    }
  } 
  // const [attachments,setAttachments]=useState([]); 
  const handleAttachmentsForEmailAutomation = async (fileList) => { 
    // let tempFileCollection = [...attachments];
    let tempFileCollection = [];
    let fileName = fileList.name;
    let base64 = await convertToBase64Format(fileList); 
    tempFileCollection.push({
      attachmentId: fileList?.uid,
      attachmentName: fileName,
      file: fileList,
      base64: base64,  
    }); 
    // setAttachments(tempFileCollection);
  };
  const UploadAttachments=async(files)=>{
      return new Promise(async(resolve,reject)=>{
        const results = await Promise.all(files.map(file => EmailService.UploadEmailAttachement(localStorage.getItem('AccountID'), file.file)));
        const allData = results.reduce((acc, result) => acc.concat(result.data), []); 
        resolve(allData);
      })
    }
  const handleFieldsToUpdate = async (data) =>{ 
    let dealObj=data.Deal; 
    if(!_.isEmpty(dealObj)){ 
      let config = {
        Type: "Create",
      method: "POST",
      url:
        "https://www.zohoapis.com/crm/v2/Deals/upsert",
      headers: { Authorization: localStorage.getItem("token") },
      data: [{...lookUpDeal,...dealObj}],
    }
    await httpService
    .post("catalyApi/workdrive", { config: config })
    .then(async (result) => { 
      
      console.log("dealUpdated Successfully",result); 
    })
    .catch((err) => {
      
      console.log("deal not Updated Successfully",err);
    });
    }
      let taskObj=data.Task;
      if(!_.isEmpty(taskObj)){
          if(taskObj.hasOwnProperty('Assignee')) {
            taskObj.Assignee = resolveAssigneeOrSupervisor(taskObj.Assignee, 'Assignee');
          }
          if(taskObj.hasOwnProperty('Supervisor')) {
            taskObj.Supervisor = resolveAssigneeOrSupervisor(taskObj.Supervisor, 'Supervisor');
          }
      if(taskData.hasOwnProperty('SubTaskROWID')){
        await AwsServerService.updateSubtask({ROWID:taskData.SubTaskROWID,...taskObj}).then(res=>{
          // setTaskData({...taskData,...taskObj})
          setTaskData((prevTaskData) => ({ ...prevTaskData, ...taskObj }));
          console.log("Task fields updated",res);
        }).catch(err=>{
          console.log("Task fields not updated",err);
        })
      }else{
        await AwsServerService.updateTask({ROWID:taskData.TaskROWID,...taskObj}).then(res=>{
          // setTaskData({...taskData,...taskObj})
          setTaskData((prevTaskData) => ({ ...prevTaskData, ...taskObj }));
          console.log("Task fields updated",res);
        }).catch(err=>{
          console.log("Task fields not updated",err);
        })
      }
    }
  } 
  
  const handleTransitionChange = async  (e, data,comment) => {
    if(accessType=="read"){
      message.warning("Action not allowed. You have only read access.") 
      return;
    }
    let key = statusOptions?.find(key => key.label == e)
    let edge = data?.Edges?.filter(res => res.id == key.key)[0]; 
    
    data = {
      ...data, Edges: processEdgeConnections(edge,data.Edges)
    }
    data = {
      ...data, Nodes: updateNodeVisitedStatus(data.Nodes,data.Edges)
    } 
  
    let prevNode = data?.Nodes?.filter(res => res.id == edge.source)[0]
    let nextNode = data?.Nodes?.filter(res => res.id == edge.target)[0];
    checkRemindersForTaskFlow({TaskFlowId:taskData.TaskFlowId,NextNode:nextNode,PrevNode:prevNode}) 
    while(nextNode.type=="diverse"){
      let nextEd = data.Edges.find(k=>k.source==nextNode.id);
      if(nextEd && nextEd.target)
      nextNode = data?.Nodes?.filter(res => res.id == nextEd.target)[0];
    }
    // let status = nextNode?.data?.label;
    let status = nextNode?.id;
    let statusLabel = nextNode?.data?.label;
    let taskStatusText = taskData?.TaskFlowObject?.Nodes?.filter(node => node.id == taskData?.TaskStatus)[0];
    let notifyArray = [taskData.Assignee, taskData.Supervisor];
    if(prevNode?.data?.state=="Start"){
      let pendingWaitingOn = getDependancyValidArrr(null,"S",selectedDependenciesCache.WaitingOn)
      if(pendingWaitingOn?.length>0){
        setWaitingPopupFlag({records:pendingWaitingOn,flag:true,taskStatus:"Start of this task is waiting on"});
        return;
      }
    }else if(nextNode?.data?.state=="Close"){
      let pendingWaitingOn = getDependancyValidArrr(null,"F",selectedDependenciesCache.WaitingOn)
      if(pendingWaitingOn?.length>0){
        setWaitingPopupFlag({records:pendingWaitingOn,flag:true,taskStatus:"Finish of this task is waiting on"});
        return;
      }
    }
    let resolveBlockingsArr=[];
    if(prevNode?.data?.state=="Start"){
      resolveBlockingsArr = getDependancyValidArrr(null,"S",selectedDependenciesCache.Blocking)
    }else if(nextNode?.data?.state=="Close"){
      resolveBlockingsArr = getDependancyValidArrr(null,"F",selectedDependenciesCache.Blocking)
    }

    let temp={ ...taskData, TaskFlowObject: data, 'TaskStatus': status }
    // setTaskData(temp);
    const userInfo = JSON.parse(localStorage.getItem("userinfo"));
    setLoader(true)
    let tempTaskData={TaskStatus:status, TaskStatusText:nextNode?.data?.label, MODIFIEDBY: userInfo.email_id};
    if(nextNode?.data?.state=="Close"){
      tempTaskData['Completion_Date'] = moment().utc().format("YYYY-MM-DD HH:mm:ss"); 
    }

    if(taskData.hasOwnProperty('SubTaskROWID')){
      setLoader(true) 
      await AwsServerService.updateSubtask({...tempTaskData, ROWID: taskData.SubTaskROWID, Status_Time: moment.utc().format('YYYY-MM-DD HH:mm:ss')}).then(async (res) => {
        setTaskData((prevTaskData) => ({ ...prevTaskData, ...temp }));
        AwsServerService.getTransitionEmailById(data.ROWID,edge?.id).then(async res=>{  
          let resArray = res?.data;
          let objectArray=[];  
          if(resArray && resArray.length>0){
            let idsArray={};
            resArray?.forEach((record,index)=>{
              record?.Attachments?.forEach(ele=>{  
                if(idsArray[index]){
                  idsArray[index].push(ele?.id);
                }else{
                  idsArray[index]=[ele?.id]
                }
              })
            }) 
     let linksArray={};
            Object.keys(idsArray).forEach(ele=>{
              let InputFieldIDs=idsArray[ele];
                let data=[...linksForAttachment];
                let links=data?.filter(el=>InputFieldIDs.includes(Number(el?.InputFieldID)))?.map(elment=>elment?.DocumentID);
                  linksArray[ele]=[...links];
              }); 
                resArray.forEach((element, index) => {
                  let obj = {
                    fromAddress:taskData?.TaskFlowObject?.BotAccountEmail,
                    askReceipt: element.AskReceipt,
                    attachments: linksArray[index],
                    bccAddress: getAccountMailIds(element.BccAddress, "BccAddress"),
                    ccAddress: getAccountMailIds(element.CcAddress, "CcAddress"),
                    content: element.EmailContent,
                    mailFormat: "html",
                    subject: modifySubjectIfApplicable(element.Subject),
                    toAddress: getAccountMailIds(element.ToAddress, 'ToAddress'),
                    token:localStorage.getItem('token'),
                    backendUrl:Config.backend_url,
                    taskType:'SubTask',
                    taskROWID:taskData.SubTaskROWID,
                  };
                  objectArray.push(obj);
                });
                Promise.all(objectArray.map(async (item) => {
                  return await EmailService.SendEmailFromTasks(item);
                })).then(() => {
                  // setAttachments([]);
                  let ids=extractEmails(objectArray);
                  let message = `Email sent by S&R automation to following Email Id/s : ${ids} due to transition change`;
                  handleCreateActivity("SUBTASK",'SubTasks',message,taskData.SubTaskROWID,null,true,"Automation");
                }).catch((err) => {
                  console.error("Error sending emails: ", err);
                  setLoader(false)
                });              
          }
        }).catch((err)=>{ 
          setLoader(false)
           console.log(err)
          })   
        await AwsServerService.getTransitionFieldUpdatesById(data.ROWID,edge?.id).then(res=>{
          let fieldData= res?.data;
         if(fieldData && fieldData?.length>0){ 
         let arr={Deal:{},Task:{},Other:{}};
         fieldData?.forEach(el=>{
          let field=el?.FieldName?.value?.split("__");
          if(field[1]=='Deal'){
            if(field[0]=="Project_Status"){
              arr.Deal={...arr.Deal,'Stage':el?.FieldValue}
            }else{
              arr.Deal={...arr.Deal,[field[0]]:el?.FieldValue}
            }
          }else if(field[1]=='Task'){
            arr.Task={...arr.Task,[field[0]]:el?.FieldValue}
          }else{
            arr.Other={...arr.Other,[field[0]]:el?.FieldValue}
          }
         }) 
         handleFieldsToUpdate(arr);
        } 
        })    
        let StatusTimelineEdgePayload = {
          CREATEDBY: userInfo?.email_id,
          TaskStatus: edge,
          TaskROWID: taskData.SubTaskROWID,
          TaskType: "Sub-Task",
          IsTransition: 1,
          UTCTimeString:  moment.utc().format('YYYY-MM-DD HH:mm:ss'),
          Comment: comment
        }
        let StatusTimelinePayload = {
          CREATEDBY: userInfo?.email_id,
          TaskStatus: nextNode,
          TaskROWID: taskData.SubTaskROWID,
          TaskType: "Sub-Task",
          IsTransition: 0,
          UTCTimeString:  moment.utc().format('YYYY-MM-DD HH:mm:ss'),
          Comment: comment
        }

        AwsServerService.createTimeline(StatusTimelineEdgePayload).then(res => {
          AwsServerService.createTimeline(StatusTimelinePayload).then(res => {
            refreshStatusTimeline(!statusTimeline);
          }).catch(e => { setLoader(false) })
        }).catch(e => { setLoader(false) })

        let text = `<a style="color:#40a9ff" id="User-${userInfo?.email_id}">${
          userInfo?.first_name + " " + userInfo?.last_name
        }</a> <span> changed the status from  </span>
        <span class="old-status" style="background-color:${taskStatusText?.data?.color && taskStatusText?.data?.color != "grey" ? taskStatusText?.data?.color : "#808080"};color:${invertColor(taskStatusText?.data?.color && taskStatusText?.data?.color != "grey" ? taskStatusText?.data?.color : "#808080",true)};">${taskStatusText?.data?.label}</span> 
        <span class="to-text"> to </span>
        <span class="new-status" style="background-color:${nextNode?.data?.color};color:${invertColor(nextNode?.data?.color,true)};">${statusLabel}</span> 
        <span class="to-text"> in </span> <a style="color:#40a9ff" id="Task-${taskData?.TaskId}">${taskData?.TaskName}</a>  
        <a style="background-color:${clientColor}" id="Client-${lookUpDeal.Account_Name.id}">${lookUpDeal.Account_Name ? lookUpDeal.Account_Name.name : ""}
        </a>  <a style="background:${dealColor}" id="Deal-${lookUpDeal.id}">${lookUpDeal.Deal_Name}</a>`;       

        await TaskService.SendNotificationToMultipleUsers(notifyArray ,AllUsers, "Task", text )
          .then((e) => {
            AppReduxContextDispatch(setNotificationFlag(!getNotification));
          })
          .catch((e) => {
            setLoader(false)
            console.log("e", e);
          });
          
        updateBlockings(resolveBlockingsArr);
      }).catch(e=>{
        setLoader(false)
        console.log(e);
      }).finally(e => {
        dispatch(Socket({ trigger: "refresh_activity", data: '' }))
        setLoader(false) 
      });
    }else{
      await AwsServerService.updateTask({...tempTaskData, ROWID:taskData.TaskROWID, Status_Time: moment.utc().format('YYYY-MM-DD HH:mm:ss')}).then(async (res)=>{
        setTaskData((prevTaskData) => ({ ...prevTaskData, ...temp }));
        AwsServerService.getTransitionEmailById(data.ROWID,edge?.id).then(async res=>{
          let resArray = res?.data;
          let objectArray=[];   
          if(resArray && resArray.length>0){
            let idsArray={};
            resArray?.forEach((record,index)=>{
              record?.Attachments?.forEach(ele=>{  
                if(idsArray[index]){
                  idsArray[index].push(ele?.id);
                }else{
                  idsArray[index]=[ele?.id]
                }
              })
            }) 
     let linksArray={};
            Object.keys(idsArray).forEach(ele=>{
              let InputFieldIDs=idsArray[ele];
                let data=[...linksForAttachment];
                let links=data?.filter(el=>InputFieldIDs.includes(Number(el?.InputFieldID)))?.map(elment=>elment?.DocumentID);
                  linksArray[ele]=[...links];
              }); 
                resArray.forEach((element, index) => {
                  let obj = {
                    fromAddress:taskData?.TaskFlowObject?.BotAccountEmail,
                    askReceipt: element.AskReceipt,
                    attachments: linksArray[index],
                    bccAddress: getAccountMailIds(element.BccAddress, "BccAddress"),
                    ccAddress: getAccountMailIds(element.CcAddress, "CcAddress"),
                    content: element.EmailContent,
                    mailFormat: "html",
                    subject: modifySubjectIfApplicable(element.Subject),
                    toAddress: getAccountMailIds(element.ToAddress, 'ToAddress'),
                    token:localStorage.getItem('token'),
                    backendUrl:Config.backend_url,
                    taskType:'Task',
                    taskROWID:taskData.TaskROWID,
                  };
                  objectArray.push(obj);
                });
                Promise.all(objectArray.map(async (item) => {
                  return await EmailService.SendEmailFromTasks(item);
                })).then(() => {
                  // setAttachments([]);
                  const ids = extractEmails(objectArray);
                  const message = `Email sent by S&R automation to following Email Id/s : ${ids} due to transition change`;
                  handleCreateActivity("TASK", 'Tasks', message, taskData.TaskROWID, null, true, "Automation");
                }).catch((err) => {
                  setLoader(false)
                  console.error("Error sending emails: ", err);
                });              
          }
        }).catch((err)=>{
          setLoader(false)
          console.log(err)
        })
        await AwsServerService.getTransitionFieldUpdatesById(data.ROWID,edge?.id).then(res=>{
         let fieldData= res?.data;
         if(fieldData && fieldData?.length>0){ 
         let arr={Deal:{},Task:{},Other:{}};
         fieldData?.forEach(el=>{
          let field=el?.FieldName?.value?.split("__"); 
          if(field[1]=='Deal'){
            if(field[0]=="Project_Status"){
              arr.Deal={...arr.Deal,'Stage':el?.FieldValue}
            }else{
              arr.Deal={...arr.Deal,[field[0]]:el?.FieldValue}
            }
          }else if(field[1]=='Task'){
            arr.Task={...arr.Task,[field[0]]:el?.FieldValue}
          }else{
            arr.Other={...arr.Other,[field[0]]:el?.FieldValue}
          }
         }) 
         handleFieldsToUpdate(arr);
        }
        })   
        let StatusTimelineEdgePayload = {
          CREATEDBY: userInfo?.email_id,
          TaskStatus: edge,
          TaskROWID:taskData.TaskROWID,
          TaskType:"Task",
          IsTransition:1,
          UTCTimeString: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
          Comment:comment
        }
        let StatusTimelinePayload = {
          CREATEDBY: userInfo?.email_id,
          TaskStatus: nextNode, 
          TaskROWID:taskData.TaskROWID,
          UTCTimeString: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
          IsTransition:0,
          TaskType:"Task",
          Comment:comment
        }
        AwsServerService.createTimeline(StatusTimelineEdgePayload).then(res=>{
          AwsServerService.createTimeline(StatusTimelinePayload).then(res=>{
            refreshStatusTimeline(!statusTimeline);
          }).catch(e=>{ setLoader(false)})
        }).catch(e=>{ setLoader(false)})

        let text = `<a style="color:#40a9ff" id="User-${userInfo?.email_id}">${
          userInfo?.first_name + " " + userInfo?.last_name
        }</a> <span> changed the status from  </span>
        <span class="old-status" style="background-color:${taskStatusText?.data?.color && taskStatusText?.data?.color != "grey" ? taskStatusText?.data?.color : "#808080"};color:${invertColor(taskStatusText?.data?.color && taskStatusText?.data?.color != "grey" ? taskStatusText?.data?.color : "#808080",true)};">${taskStatusText?.data?.label}</span> 
        <span class="to-text"> to </span> 
        <span class="new-status" style="background-color:${nextNode?.data?.color};color:${invertColor(nextNode?.data?.color,true)};">${statusLabel}</span> 
        <span class="to-text"> in </span> <a style="color:#40a9ff" id="Task-${taskData?.TaskId}">${taskData?.TaskName}</a>  
        <a style="background-color:${clientColor}" id="Client-${lookUpDeal.Account_Name.id}">${lookUpDeal.Account_Name ? lookUpDeal.Account_Name.name : ""}
        </a>  <a style="background:${dealColor}" id="Deal-${lookUpDeal.id}">${lookUpDeal.Deal_Name}</a>`;

        await TaskService.SendNotificationToMultipleUsers(notifyArray ,AllUsers, "Task", text )
          .then((e) => {
            AppReduxContextDispatch(setNotificationFlag(!getNotification));
          })
          .catch((e) => {
            setLoader(false)
            console.log("e", e);
          });
          
        updateBlockings(resolveBlockingsArr);
      }).catch(e=>{
        console.log(e);
        setLoader(false)
      }).finally(e => {
        dispatch(Socket({ trigger: "refresh_activity", data: '' }))
        setLoader(false)
      });
    }
    setLoader(false)
    setSelectedBlueprintData({...selectedBlueprintData,data:data})
    getBlueprintDataOptions(temp, temp.TaskStatus);
  }
  const handleDropDownChange = (e, data) => { 
    if (data == "Account") {
      setAccountSelected(e);
      setDealSelected();
    } else if (data == "Project") {
      setDealSelected(e);
    } else {
      
      let temp = { ...taskData };
      let oldBlueprintName = temp?.TaskFlowObject?.Name;
      if(data=="TaskFlowId"){
        let bluePrint = allBlueprintsData?.find(d=>d.ROWID==e);
        if(bluePrint){
          temp["TaskFlowObject"] = bluePrint;
          setSelectedBlueprintData({...selectedBlueprintData,data:bluePrint})
          let node = bluePrint?.Nodes?.find(k=>k.data.state=="Start");
          temp["TaskStatus"] = node?.id;
          let resolveBlockingsArr=[];
          if(node){
            resolveBlockingsArr = [...selectedDependenciesCache.Blocking,...selectedDependenciesCache.WaitingOn]
          }
          if(taskModalState.action == "edit"){
            if (!isSubTaskView) {
              AwsServerService.updateTask({ Completion_Date:null, TaskStatus:node?.id,TaskFlowId:bluePrint.ROWID,TaskFlowObject:bluePrint,ROWID: taskData.TaskROWID , MODIFIEDBY: userInfo.email_id}).then(async (res) => {
                // reopenDependancies(resolveBlockingsArr.filter(d=>d.IsResolved==1));
                handleDependencyAfterFlowChange(selectedDependenciesCache,temp);
                if(selectedTable == "tasks"){
                  let zuidArr = [];
                  let text = '';
                    text = (
                      <>
                        changed Task Flow from{' '}
                        <span style={{ fontWeight: 'bold' , whiteSpace:"nowrap"}}>
                          {oldBlueprintName}
                        </span>{' '}
                        to{' '}
                        <span style={{ fontWeight: 'bold', whiteSpace:"nowrap" }}>
                          {bluePrint.Name}
                        </span>
                        <span>{' '} in task</span>
                      </>
                    );
                    zuidArr = [...zuidArr, temp.Assignee, temp.Supervisor]
  
                  const renderToHtml = (element) =>
                  require('react-dom/server').renderToString(element);
                  await TaskService.SendAssignedNotification(zuidArr,allAppUsers,temp,lookUpDeal,"Task", renderToHtml(text)).then(e=>{
                    AppReduxContextDispatch(setNotificationFlag(!getNotification));
                  }).catch(e=>{})
                }
              }).catch(e=>{
                console.log(e);
              }).finally(e => {
                dispatch(Socket({ trigger: "refresh_activity", data: '' }))
              });
            }else{
              AwsServerService.updateSubtask({ Completion_Date:null, TaskStatus:node?.id,TaskFlowId:bluePrint.ROWID,TaskFlowObject:bluePrint,ROWID: taskData.SubTaskROWID , MODIFIEDBY: userInfo.email_id}).then(async (res) => {
                // reopenDependancies(resolveBlockingsArr.filter(d=>d.IsResolved==1));
                handleDependencyAfterFlowChange(selectedDependenciesCache,temp);
                let zuidArr = [];
                  let text = '';
                    text = (
                      <>
                        changed Task Flow from{' '}
                        <span style={{ fontWeight: 'bold' , whiteSpace:"nowrap"}}>
                          {oldBlueprintName}
                        </span>{' '}
                        to{' '}
                        <span style={{ fontWeight: 'bold', whiteSpace:"nowrap" }}>
                          {bluePrint.Name}
                        </span>
                        <span>{' '} in sub task</span>
                      </>
                    );
                    zuidArr = [...zuidArr, temp.Assignee, temp.Supervisor]
  
                  const renderToHtml = (element) =>
                  require('react-dom/server').renderToString(element);
                  await TaskService.SendAssignedNotification(zuidArr,allAppUsers,temp,lookUpDeal,"Task", renderToHtml(text)).then(e=>{
                    AppReduxContextDispatch(setNotificationFlag(!getNotification));
                  }).catch(e=>{})
              }).catch(e=>{
                console.log(e);
              }).finally(e => {
                dispatch(Socket({ trigger: "refresh_activity", data: '' }))
              });
            }
          }
        }
        getBlueprintDataOptions(temp, temp.TaskStatus);
      }
      
      temp[data] = e;
      setTaskData(temp);
    }
  };
  const getAntSelectDropDown = (data) => {
    let options = data == "Project" ? allDealsData : allAccountsData?.sort((a, b) => a.label.localeCompare(b.label));
    return (
      <Select
        disabled={
          (insertBelowData?.flag)||(data == "Project" && accountSelected == "Miscellaneous") ||
          ((data == "Project" || data == "Account") && createPiplineModalState)|| taskModalState.action == "edit"
        }
        showSearch
        size={"small"}
        className="form-control"
        popupClassName={
          data == "Priority"
            ? "dropdown-create-task"
            : "dropdown-create-task header-dropdowns"
        }
        placeholder={data == "Account" ? "Select Account" : "Select Project"}
        filterOption={(input, option) =>
          (option?.label ?? "")?.toLowerCase()?.includes(input?.toLowerCase())
        }
        onChange={(e) => {
          handleDropDownChange(e, data);
        }}
        value={
          data == "Account"
            ? accountSelected
            : data == "Project"
            ? dealSelected
            : taskData[data]
        }
        options={options}
        suffixIcon={<CaretDownFilled />}
      />
    );
  };
  useEffect(e=>{
    if(allBlueprintsData){
      let arr = allBlueprintsData?.map((item) => {
        return ({
          value: item?.ROWID,
          label: item?.Name,
          // key: item?.Name,
        });
      })
      setBluePrintDropDownOptions(arr);
    }
  },[allBlueprintsData]) 

  useEffect(e=>{
    if(BluePrintDropDownOptions.length>0 && AllUsers.length>0 && taskData?.TaskFlowObject && viewTaskData){
      let accessLevel=accessType;
      let taskD={...taskData};
      let deal=viewTaskData?.Pipeline?.DealName;  
      let FlowId = taskD.TaskFlowObject?.ROWID;
      let arr = BluePrintDropDownOptions?.map((item) => {  
        let dataForAccess = accessControlData.current[item.value]; 
        const Access=checkForAccessLevel(userInfo,taskD,deal,lookUpDeal,dataForAccess,AllUsers,allCacheUserRoles,allCacheRoles,moduleContacts);
        if(item.value == FlowId){
          accessLevel=Access;
        }
        return ({...item, key: Access})
      }).filter(option => option.key !== "none" || option.value === FlowId);
      setAccessType(accessLevel);
      console.log("AccesssType",accessLevel,arr);
      setAvailableFlowDropDownOptions(arr);
    }else{
      setAccessType('write');
      setAvailableFlowDropDownOptions([]);
    }
  },[BluePrintDropDownOptions,AllUsers,taskData.TaskFlowObject])

  const handlePopConfirm = (data) => {
    setIsPopConfirmVisible(false);
    handleDropDownChange(selectedValue, data);
  };

  const handlePopCancel = () => {
    setIsPopConfirmVisible(false);
    console.log("Blueprint change cancelled.");
  };

  const handleSelectChange = (e,data) => { 
    if (taskModalState.action === "edit") {
      setSelectedValue(e);
      setIsPopConfirmVisible(true);
    } else {
      handleDropDownChange(e, data);
    }
  }; 
  const getBlueprintsDropDown = (data) => {
    
    return (
      <>
      <Popconfirm
        title="Are you sure you want to change the blueprint?"
        description="This action may modify task flow details and dependencies."
        open={isPopConfirmVisible}
        onConfirm={()=>{handlePopConfirm(data)}}
        onCancel={handlePopCancel}
        okText="Yes"
        cancelText="No"
        zIndex={99991}
      />
      <Select
        showSearch
        size={"small"}
        className="form-control"
        popupClassName={"dropdown-create-task header-dropdowns"}
        placeholder={"Select blueprint"}
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        onChange={(e,option)=>{
          if(accessType=="read"||accessType=='none'){
          message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
          return;
          } 
          if (option.key == "read") {
            Swal.fire({
              title: 'Confirm Change',
              text: `You only have Read access for this Flow. Do you wish to continue?`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
            }).then((result) => {
              if (result.isConfirmed) { 
                handleSelectChange(e,data);
              } else { 
                return;
              }
            });
          }else{
            handleSelectChange(e,data);
          } }}
        value={taskData[data]}
        options={viewTaskData?availableFlowDropDownOptions:BluePrintDropDownOptions}
        suffixIcon={<CaretDownFilled />}
      />
    </>
    );
};

  const onChangeTransion= (e,comment) => {
    if(accessType=="read"||accessType=='none'){
    message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
    return;
    }
      if(anotherSessionActiveFlag.Active){ 
        swal({
          title: 'Clock is running!',
          text: 'Do you want to stop the clock?',
          icon: 'warning',
          showCancelButton: true,  
          buttons: ['No', 'Yes'],   
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result) { 
            setTransitionChangeState(true); 
            setTimeout(() => {
              handleTransitionChange(e, taskData?.TaskFlowObject,comment);
            }, 200);
          } 
        });
      }else{
        handleTransitionChange(e, taskData?.TaskFlowObject,comment);
      }
    const taskNameElements = document.querySelectorAll('.swalDiv'); 
      taskNameElements.forEach(taskNameElement => {
          taskNameElement.addEventListener('click', (e) => {
              swal.close();  
              // let data2 = result.data.find(task => task === e.currentTarget.dataset.task); 
              let data2 = e.currentTarget.dataset.task;   
              // let tasksData = { ...allTasksAndSubtasks };
              let step=data2.split('_'); 
                  // const newData = tasksData[step[0]].get(Number(step[1]));
                  if(Number(step[1])){
                    setLoader(true);
                    if(step[0]=='Tasks'){
                      AwsServerService.getTaskById(Number(step[1])).then(res=>{
                        let k=res[0]?.taskInfo;
                        if(k){
                          handleHistoryAdd()
                          viewTaskFunction(k,"TASK");
                          setLoader(false);
                          // setIsSubTaskView(true);
                        }
                      }).catch(e=>{
                        setLoader(false);
                      })
                    }else{
                      AwsServerService.getSubTaskBySubTaskId(Number(step[1])).then(res=>{
                        let k=res[0]?.taskInfo;
                        if(k){
                          handleHistoryAdd()
                          viewTaskFunction(k,"SUBTASK");
                          setLoader(false);
                          // setIsSubTaskView(true);
                        }
                      }).catch(e=>{
                        setLoader(false);
                      })
                    }
                  }  
          });
    }) 
    
  }

  const rangePresets = [
    {
      label: 'Today',
      value: [dayjs().startOf('day'), dayjs().endOf('day')],
    },
    {
      label: 'Tomorrow',
      value: [dayjs().add(1, 'day').startOf('day'), dayjs().add(1, 'day').endOf('day')],
    },
    {
      label: 'This Week',
      value: [dayjs().startOf('week'), dayjs().endOf('week')],
    },
    {
      label: 'Next Week',
      value: [
        dayjs().add(1, 'week').startOf('week'),
        dayjs().add(1, 'week').endOf('week'),
      ],
    },
    {
      label: 'Next Two Weeks',
      value: [
        dayjs().add(1, 'week').startOf('week'),
        dayjs().add(2, 'week').endOf('week'),
      ],
    },
    {
      label: 'This Month',
      value: [
        dayjs().startOf('month').isBefore(dayjs().startOf('day')) ? dayjs().startOf('day') : dayjs().startOf('month'),
        dayjs().endOf('month'),
      ],
    },
    {
      label: 'Next Month',
      value: [
        dayjs().add(1, 'month').startOf('month'),
        dayjs().add(1, 'month').endOf('month'),
      ],
    },
    {
      label: 'Next Two Months',
      value: [
        dayjs().add(1, 'month').startOf('month'),
        dayjs().add(2, 'month').endOf('month'),
      ],
    },
    {
      label: 'This Year',
      value: [
        // Start from today if the year has blocked dates before today
        dayjs().startOf('year').isBefore(dayjs().startOf('day')) ? dayjs().startOf('day') : dayjs().startOf('year'),
        dayjs().endOf('year'),
      ],
    },
  ];


  const DueDateRangePopover = () => {
    return <DatePicker.RangePicker 
    value={getDates([taskData.StartDate,taskData.DueDate])}
    disabledDate={disabledDate}
    format={"MM-DD-YYYY"}
    presets={rangePresets}
    onChange={changeDateRange}
    style={{width: "240px", color:"#5b6c97"}} 
    placement={"bottomRight"} 
    /> 
  };
  const handleHistoryAdd=()=>{ 
    let history=[...taskHistory]
    history.push(taskData)
    setTaskHistory(history);
  }
  const handleBack = () => { 
    const previousHistory = [...taskHistory]; 
    const lastTask = previousHistory.pop();
    // let type=lastTask?.hasOwnProperty('SubTaskROWID')?'SUBTASK':'TASK';
    if(lastTask){
      if(selectedTable=='tasks'){
      if(lastTask?.hasOwnProperty('SubTaskROWID')){
        AwsServerService.getSubTaskBySubTaskId(lastTask.SubTaskId).then(res=>{
          let k=res[0]?.taskInfo;
          if(k){ 
            viewTaskFunction(k,"SUBTASK");
            setLoader(false);
            setTaskHistory(previousHistory) 
          }
        }).catch(e=>{
          setLoader(false);
        })
      }else{
        AwsServerService.getTaskById(lastTask.TaskId).then(res=>{
          let k=res[0]?.taskInfo;
          if(k){ 
            viewTaskFunction(k,"TASK");
            setLoader(false);
            setTaskHistory(previousHistory) 
          }
        }).catch(e=>{
          setLoader(false);
        })
      }
    }else{
      if(lastTask?.hasOwnProperty('SubTaskROWID')){
        AwsServerService.getSubTaskBySubTaskIdFromTemplate(lastTask?.SubTaskROWID).then(res=>{
          let k= res[0]?.taskInfo || res[0][0].taskInfo; 
          if(k){ 
            viewTaskFunction(k,"SUBTASK");  
          }
        }) 
      }else{
        AwsServerService.getTaskByIdFromTemplate(lastTask?.TaskROWID).then(res=>{
          let k= res[0]?.taskInfo || res[0][0].taskInfo; 
          if(k){ 
            viewTaskFunction(k,"TASK");  
          }
        }) 
      } 
    } 
    }
  };
  function openTaskFromDependencies(data){ 
    setRefreshTasksSubtasks(true);
    const [type,id]=data?.value?.split('_');
    setLoader(true)
    if(selectedTable=='tasks'){
    if(type=='Tasks'){
      AwsServerService.getTaskById(number(id)).then(res=>{
        let k=res[0]?.taskInfo;
        if(k){
          handleHistoryAdd();
          viewTaskFunction(k,"TASK");
          setLoader(false)
        }
      }).catch(e=>{
        setLoader(false);
      }) 
    }else{
      AwsServerService.getSubTaskBySubTaskId(number(id)).then(res=>{
        let k=res[0]?.taskInfo;
        if(k){
          handleHistoryAdd();
          viewTaskFunction(k,"SUBTASK");
          setLoader(false);
        }
      }).catch(e=>{
        setLoader(false);
      })   
    }
  }else{
      if(type=='Tasks'){
        AwsServerService.getTaskByIdFromTemplate(number(id)).then(res=>{
          let k= res[0]?.taskInfo || res[0][0].taskInfo; 
          if(k){ 
            handleHistoryAdd();
            viewTaskFunction(k,"TASK"); 
            setLoader(false); 
          }
        }) 
      }else{
        AwsServerService.getSubTaskBySubTaskIdFromTemplate(number(id)).then(res=>{
          let k= res[0]?.taskInfo || res[0][0].taskInfo; 
          if(k){ 
            handleHistoryAdd();
            viewTaskFunction(k,"SUBTASK"); 
            setLoader(false) 
          }
        }) 
      } 
    }
    setLoader(false); 
    setIsDependencyModalOpen(false);
  }
  const handleCreateActivity = (Ftype,sourceTaskType, message, ROWID, template,blockRefresh,Owner)=>{
    let type=sourceTaskType=='Tasks'?'TASK':'SUBTASK';
    if(template){
      type=sourceTaskType=='Tasks'?'TASKTEMPLATE':'SUBTASKTEMPLATE';
    }
    let payload={
      SourceId:ROWID,
      ActivityType:type,
      Message:message,
      ActivityOwner:Owner||userinfo.email_id,
      FilterType:Ftype
    }  
   AwsServerService.createActivity(payload).then(res=>{
    if(!blockRefresh){
      dispatch(Socket({trigger:"refresh_activity",data:''}))
    }
   }).catch(errMessage=>{
    console.log('Error saving Activity',errMessage);
   })
}
const handleSaveDependencies = async (data, deptype) => {
  const access = canAccess(accessContext, selectedTable=="tasks"?"Tasks":"Pipeline", selectedTable=="tasks"?"Create":"Edit")
  if(!access || access == "NO" ){message.error("Permission Denied"); return}
  let sourceTaskType = taskData.hasOwnProperty('SubTaskROWID') ? 'SubTasks' : 'Tasks';
  let sourceId = taskData.hasOwnProperty('SubTaskROWID') ? taskData.SubTaskROWID : taskData.TaskROWID;
  if (!viewTaskData) {
    let obj = { ...selectedDependenciesCache };
    obj[deptype].push({ ...data, sourceValue: `${sourceTaskType}_${sourceId}`, DependancyType: deptype });
    setSelectedDependenciesCache(obj)
    setIsDependencyModalOpen(false);
    return;
  }
  try {
    setLoader(true);
     //logic to check already resolved dep
  let isResolvedDependancy = 0;
  let currentStatusOfSourceTask = taskData?.TaskFlowObject?.Nodes?.find(k => k.id == taskData.TaskStatus);
  let currentStatusOfTargetTask = data.taskData?.TaskFlowObject?.Nodes?.find(k => k.id == data?.taskData.TaskStatus);
  let tempTaskS;
  let tempTaskState;
  let tempTaskSAlt;
  let tempTaskStateAlt;
  if(deptype=="WaitingOn"){
    tempTaskS = data.toStatus;
    tempTaskState = currentStatusOfTargetTask?.data?.state
    tempTaskSAlt = data.thisStatus
    tempTaskStateAlt = currentStatusOfSourceTask?.data?.state;
  }else{
    tempTaskS = data.thisStatus;
    tempTaskState = currentStatusOfSourceTask?.data?.state
    tempTaskSAlt = data.toStatus;
    tempTaskStateAlt = currentStatusOfTargetTask?.data?.state
  }
  if ((tempTaskS == "S" && tempTaskState != "Start") || (tempTaskSAlt == "S" && tempTaskStateAlt != "Start")) {
    isResolvedDependancy = 1;
  } else if ((tempTaskS == "F" && tempTaskState == "Close") || (tempTaskSAlt == "F" && tempTaskStateAlt == "Close")) {
    isResolvedDependancy = 1;
  }
  // -- end -- logic to check already resolved dep
    if (selectedTable == 'tasks') {
      const [type, id] = data.value.split('_');
      const payload = {
        TargetTaskId: id,
        STaskType: sourceTaskType,
        SourceTaskId: sourceId,
        TaskType: type,
        DependancyType: deptype,
        IsResolved:isResolvedDependancy,
        CREATEDBY: localStorage.getItem("ZUID"),
        TargetDependencyStatus: data.TargetDependencyStatus,
        SourceDependencyStatus: data.SourceDependencyStatus,
      }
      return AwsServerService.createDependency(payload).then(async (e) => {

        let selections = [...selectedDependencies[deptype]];
        selections.push({ ...data, ROWID: e.data[0]?.insertId, sourceValue: `${sourceTaskType}_${sourceId}`,CREATEDBY: localStorage.getItem("ZUID") });
        // setSelectedDependenciesCache({
        //   ...selectedDependencies,
        //   [deptype]: selections,
        // }) 
        let dependencytype = deptype == 'Blocking' ? 'Blocking' : 'Waiting on';
        let message = `USER added ${dependencytype} dependency : where ${data.SourceDependencyStatus == "S" ? "Start" : "Finish"} of this 
          task is ${dependencytype} ${data.TargetDependencyStatus == "S" ? "Start" : "Finish"} of ${data.value}`
        handleCreateActivity('DEPENDENCY',sourceTaskType, message, sourceId, null, true);
        let typeOfDep = dependencytype == 'Blocking' ? 'WaitingOn' : 'Blocking';
        const reversePayload = {
          TargetTaskId: sourceId,
          STaskType: type,
          SourceTaskId: id,
          TaskType: sourceTaskType,
          IsResolved:isResolvedDependancy,
          DependancyType: typeOfDep,
          CREATEDBY: localStorage.getItem("ZUID"),
          TargetDependencyStatus: data.SourceDependencyStatus,
          SourceDependencyStatus: data.TargetDependencyStatus,
        }

        await AwsServerService.createDependency(reversePayload).then(res => {
          let typ = typeOfDep == 'Blocking' ? 'Blocking' : 'Waiting on';
          let message2 = `USER added ${typ} dependency : where ${data.TargetDependencyStatus == "S" ? "Start" : "Finish"} of this 
          task is ${typ} ${data.SourceDependencyStatus == "S" ? "Start" : "Finish"} of ${sourceTaskType}_${sourceId}`
          handleCreateActivity('DEPENDENCY',type, message2, id);
        }).catch((err) => swal('Failed', 'Error saving reverse dependency', 'Alert'))
      }).catch(err => swal('Failed', 'Error saving dependency', 'Alert')).finally(e => {
        setLoader(false);
        getAllDependenciesForTask(taskData?.hasOwnProperty('SubTaskROWID'), taskData?.hasOwnProperty('SubTaskROWID') ? taskData?.SubTaskROWID : taskData?.TaskROWID);
      })
    } else {
      const [type, id] = data.value.split('_');
      const payload = {
        TargetTaskId: id,
        STaskType: sourceTaskType,
        SourceTaskId: sourceId,
        TaskType: type,
        DependancyType: deptype,
        IsResolved:isResolvedDependancy,
        PipelineROWID: taskData.PipelineROWID,
        CREATEDBY: localStorage.getItem("ZUID"),
        TargetDependencyStatus: data.TargetDependencyStatus,
        SourceDependencyStatus: data.SourceDependencyStatus
      }
      return AwsServerService.createTempDependency(payload).then(async e => {

        let selections = [...selectedDependencies[deptype]];
        selections.push({ ...data, ROWID: e.data[0]?.insertId, sourceValue: `${sourceTaskType}_${sourceId}`,CREATEDBY: localStorage.getItem("ZUID") });
        // setSelectedDependenciesCache({
        //   ...selectedDependencies,
        //   [deptype]: selections,
        // })
        let dependencytype = deptype == 'Blocking' ? 'Blocking' : 'Waiting';
        let thisStatus=data.SourceDependencyStatus=='S'?'Start':'Finish';
        let toStatus=data.TargetDependencyStatus=='S'?'Start':'Finish';
        let message = `USER added ${dependencytype} dependency : where ${thisStatus} of this 
          task is ${dependencytype} ${toStatus} of ${data.value}`
        handleCreateActivity('DEPENDENCY',sourceTaskType, message, sourceId, true, true);
        let typeOfDep = dependencytype == 'Blocking' ? 'WaitingOn' : 'Blocking';
        const reversePayload = {
          TargetTaskId: sourceId,
          STaskType: type,
          SourceTaskId: id,
          TaskType: sourceTaskType,
          DependancyType: typeOfDep,
          IsResolved:isResolvedDependancy,
          CREATEDBY: localStorage.getItem("ZUID"),
          TargetDependencyStatus: data.SourceDependencyStatus,
          SourceDependencyStatus: data.TargetDependencyStatus,
        }
        await AwsServerService.createTempDependency(reversePayload).then(res => {
          let typ = typeOfDep == 'Blocking' ? 'Blocking' : 'Waiting';
          let message2 = `USER added ${typ} dependency : where ${toStatus} of this 
          task is ${typ} ${thisStatus} of ${sourceTaskType}_${sourceId}`
          handleCreateActivity('DEPENDENCY',type, message2, id, true);
        });
      }).catch(err => swal('Failed', 'Error saving dependency', 'Alert')).finally(e => {
        setLoader(false);
        getAllDependenciesForTask(taskData?.hasOwnProperty('SubTaskROWID'), taskData?.hasOwnProperty('SubTaskROWID') ? taskData?.SubTaskROWID : taskData?.TaskROWID);
      });
    }
    } catch {

    }
  }

  function handleDeleteDependency(e,isWaiting,taskName){
    if(canDelete == "NO"){message.error("Permission Denied"); return}
    let [type,id]=e.value.split('_');
    if(!viewTaskData){
      setLoader(true);
      if(isWaiting=='waiting'){
        let selections=[...selectedDependenciesCache.WaitingOn];
        let data=selections?.filter(t=>t.value!==e.value);
        if(data.length==0){
          setDropdownCount({...dropdowncount,'WaitingOn':0});
        }
        setSelectedDependenciesCache({...selectedDependenciesCache,'WaitingOn':data})
      }else{
        let selections=[...selectedDependenciesCache.Blocking];
        let data=selections?.filter(t=>t.value!==e.value);
        if(data.length==0){
          setDropdownCount({...dropdowncount,'Blocking':0});
        } 
        setSelectedDependenciesCache({...selectedDependenciesCache,'Blocking':data}) 
      }
      setLoader(false);
      return;
    }
    let sourceType=taskData.hasOwnProperty('SubTaskROWID')?'SubTasks':'Tasks';
    let sourceId=taskData.hasOwnProperty('SubTaskROWID')?taskData.SubTaskROWID:taskData.TaskROWID; 
    if(selectedTable=='tasks'){
        
      AwsServerService.deleteDependency(sourceId, sourceType, id, type, e.SourceDependencyStatusId, e.TargetDependencyStatusId).then(r => {
        if (isWaiting == 'waiting') {
          let selections = [...selectedDependenciesCache.WaitingOn];
          let data = selections?.filter(t => t.ROWID != e.ROWID);
          if (data.length == 0) {
            setDropdownCount({ ...dropdowncount, 'WaitingOn': 0 });
          }
          setSelectedDependenciesCache({ ...selectedDependenciesCache, 'WaitingOn': data })
        } else {
          let selections = [...selectedDependenciesCache.Blocking];
          let data = selections?.filter(t => t.ROWID != e.ROWID);
          if (data.length == 0) {
            setDropdownCount({ ...dropdowncount, 'Blocking': 0 });;
          }
          setSelectedDependenciesCache({ ...selectedDependenciesCache, 'Blocking': data })
        }
        let dependencytype = isWaiting == 'waiting' ? 'Waiting on' : 'Blocking';
        let val = e.value?.split('_');
        let newData = allTasksAndSubtasks[val[0]]?.get(Number(val[1]));
        let message = `USER removed ${dependencytype} dependency : where ${e.SourceDependencyStatusId == "S" ? "Start" : "Finish"} of this 
            task was ${dependencytype} ${e.TargetDependencyStatusId == "S" ? "Start" : "Finish"} of ${e.value}`
        handleCreateActivity('DEPENDENCY',sourceType, message, sourceId, null, true);
        let deptype = isWaiting == 'waiting' ? 'Blocking' : 'Waiting on';
        let targetType = newData.hasOwnProperty('SubTaskROWID') ? 'SubTasks' : 'Tasks';
        let targetId = newData.hasOwnProperty('SubTaskROWID') ? newData.SubTaskROWID : newData.TaskROWID;
        let messages = `USER removed ${deptype} dependency : where ${e.TargetDependencyStatusId == "S" ? "Start" : "Finish"} of this 
            task was ${deptype} ${e.SourceDependencyStatusId == "S" ? "Start" : "Finish"} of ${sourceType}_${sourceId}`
        handleCreateActivity('DEPENDENCY',targetType, messages, targetId);
      }).catch(e=>{
        console.log(e);
        
      }).finally(e => {
        setLoader(false);
        getAllDependenciesForTask(taskData?.hasOwnProperty('SubTaskROWID'), taskData?.hasOwnProperty('SubTaskROWID') ? taskData?.SubTaskROWID : taskData?.TaskROWID);
      })
    }else{
      AwsServerService.deleteTempDependency(sourceId, sourceType, id, type, e.SourceDependencyStatusId, e.TargetDependencyStatusId).then(r => {
        if (isWaiting == 'waiting') {
          let selections = [...selectedDependenciesCache.WaitingOn];
          let data = selections?.filter(t => t.ROWID !== e.ROWID);
          if (data.length == 0) {
            setDropdownCount({ ...dropdowncount, 'WaitingOn': 0 });
          }
          setSelectedDependenciesCache({ ...selectedDependenciesCache, 'WaitingOn': data })
        } else {
          let selections = [...selectedDependencies.Blocking];
          let data = selections?.filter(t => t.ROWID !== e.ROWID);
          if (data.length == 0) {
            setDropdownCount({ ...dropdowncount, 'Blocking': 0 });;
          }
          setSelectedDependenciesCache({ ...selectedDependenciesCache, 'Blocking': data })
        }
        let dependencytype = isWaiting == 'waiting' ? 'Waiting on' : 'Blocking';
        let val = e.value?.split('_');
        let newData = allTasksAndSubtasks[val[0]]?.get(Number(val[1]));
        let message = `USER removed ${dependencytype} dependency : where ${e.SourceDependencyStatusId == "S" ? "Start" : "Finish"} of this 
            task was ${dependencytype} ${e.TargetDependencyStatusId == "S" ? "Start" : "Finish"} of ${e.value}`
        handleCreateActivity('DEPENDENCY',sourceType, message, sourceId, "template", true);
        let deptype = isWaiting == 'waiting' ? 'Blocking' : 'Waiting on';
        let targetType = newData.hasOwnProperty('SubTaskROWID') ? 'SubTasks' : 'Tasks';
        let targetId = newData.hasOwnProperty('SubTaskROWID') ? newData.SubTaskROWID : newData.TaskROWID;
        let messages = `USER removed ${deptype} dependency : where ${e.TargetDependencyStatusId == "S" ? "Start" : "Finish"} of this 
            task was ${deptype} ${e.SourceDependencyStatusId == "S" ? "Start" : "Finish"} of ${sourceType}_${sourceId}`
        handleCreateActivity('DEPENDENCY',targetType, messages, targetId, "template")
      }).catch(e=>{
        console.log(e);
        
      }).finally(e => {
        setLoader(false);
        getAllDependenciesForTask(taskData?.hasOwnProperty('SubTaskROWID'), taskData?.hasOwnProperty('SubTaskROWID') ? taskData?.SubTaskROWID : taskData?.TaskROWID);
      })
    }
  }
  const [filteredFields, setFilteredFields] = useState(DealFields);
  let hideArray = [
    "Last_Activity_Time",
    "Tag",
    "Lead_Conversion_Time",
    "NYC_Project",
    "Sales_Cycle_Duration",
    "Overall_Sales_Duration",
    "Locked__s",
    "Certification",
    "Conjunction_Application_Number",
    "Stage",
    "Reason_For_Loss__s",
    "Amount",
    "Expected_Revenue",
    "Type",
    "Next_Step",
    "Probability",
    "Lead_Source",
    "Contact_Name",
    "Campaign_Source",
    "Accounts",
    "Project_Date",
    "Partial",
    "Change_Log_Time__s",
    "Description",
    "Record_Image",
    "Block",
    "Address",
    "Total_Interconnections",
    "Project_Status_ID",
    "Service_Requested",
    "Borough_Number",
    "Currency",
    "Exchange_Rate",
    "Previous_Solar_Application",
    "Violation_Information",
    "Tax_Abatement",
    "Electrical_Diagram",
    "Asbestos_Investigation",
    "Pipeline",
    "Asbestos",
    "zohoworkdriveforcrm__Workdrive_Folder_URL",
    "zohoworkdriveforcrm__Workdrive_Folder_ID",
    "Number",
    "Story_Number",
    "Notes_ID",
    "Project_Status_ID",
    "Deal_Status",
    "Project_ID",
    "Structural_Letter",
    "Service_Requested_ID",
  ];

  const getLookUpData = (data, type, filedName) =>{
    if(hideArray.includes(data)){
      return;
    }
    if(data && typeof data == "object"){
      return <span className="Elipsis-Class" style={{fontWeight:"600", color: type == "table" ? "#5a6c97" : "#ffffff", fontSize: "12px"}}>{(data.name)?.toUpperCase()}</span>
    }
    if(data && filedName == "Closing_Date"){
      return <span className="Elipsis-Class" style={{fontWeight:"600", color: type == "table" ? "#5a6c97" : "#ffffff", fontSize: "12px"}}>{moment(new Date(data)).format("MM/DD/YYYY")}</span>
    }
    return <span className="Elipsis-Class" style={{fontWeight:"600", color: type == "table" ? "#5a6c97" : "#ffffff", fontSize: "12px"}}>{typeof data == "string" ? data?.toUpperCase() : data}</span>
  }
  const [searchedValue, setSearchedValue] = useState('');
  const handleSearchLookUp = (value) => {
    const lowercasedValue = value?.toLowerCase();
    setSearchedValue(lowercasedValue);
    // Filter DealFields based on the field name or its corresponding data in lookUpDeal
    const filtered = DealFields.filter((one) => {  
      if(one.field == "Project_Status"){
        one.field = "Stage"
      }
      const fieldValue = one.field?.toLowerCase();
      let lookUpValue = '';
      if (lookUpDeal && lookUpDeal[one.field]) {
        if (typeof lookUpDeal[one.field] === "object") {
            // Handle if the value is an object and get the `name` property
            lookUpValue = (lookUpDeal[one.field].name || "")?.toLowerCase();
        } else if (typeof lookUpDeal[one.field] === "number") {
            // Convert numbers to string
            lookUpValue = lookUpDeal[one.field].toString();
        } else {
            // Handle as a string
            lookUpValue = lookUpDeal[one.field]?.toLowerCase();
        }
    }
      return (
        fieldValue?.includes(lowercasedValue) ||
        lookUpValue?.includes(lowercasedValue)
      );
    });

    setFilteredFields(filtered);
  };

  const AddLookUpFields = (label, value) => {
    let lookUpdata = { ...taskData };
      if(!lookUpdata["LookUpFields"]){
        lookUpdata["LookUpFields"] = [];
      }
      
      // If action is "edit", update API and state
      if (taskModalState.action === "edit") {
        const updatedArray = [...lookUpdata["LookUpFields"]? lookUpdata["LookUpFields"] : [], label];
        const data2 = {
          ROWID: lookUpdata.hasOwnProperty("SubTaskROWID") ? lookUpdata.SubTaskROWID : lookUpdata.TaskROWID,
          LookUpFields: updatedArray,
          MODIFIEDBY: userInfo.email_id,
        };
        
        const updateService = lookUpdata.hasOwnProperty("SubTaskROWID") 
          ? AwsServerService.updateSubtask
          : AwsServerService.updateTask;
  
        updateService(data2)
          .then(() => {
            // setPageRefreshData(prev => !prev);
          })
          .catch(er => console.log("Er", er));
        
        lookUpdata["LookUpFields"] = updatedArray;
        setTaskData(lookUpdata);
  
      } else {
        lookUpdata["LookUpFields"].push(label);
        setTaskData(lookUpdata);
      }
  };
  
  const removeLookUpField = (label) => {
    let data = { ...taskData };
    const updatedArray = data["LookUpFields"].filter(item => item !== label);
  
    if (taskModalState.action === "edit") {
      const data2 = {
        ROWID: data.hasOwnProperty("SubTaskROWID") ? data.SubTaskROWID : data.TaskROWID,
        LookUpFields: updatedArray,
        MODIFIEDBY: userInfo.email_id,
      };
  
      const updateService = data.hasOwnProperty("SubTaskROWID") 
        ? AwsServerService.updateSubtask 
        : AwsServerService.updateTask;
  
      updateService(data2)
        .then(() => {
          // setPageRefreshData(prev => !prev);
        })
        .catch(er => console.log("Er", er));
        data["LookUpFields"] = updatedArray;
        setTaskData(data);
    }else{
      data["LookUpFields"] = updatedArray;
      setTaskData(data);
    }
  };
  
const getTableForLookupFields = () => {
  // Separate selected and non-selected fields
  let data = {...taskData}
  if(!data["LookUpFields"]){
    data["LookUpFields"] = [];
  }
  const selectedFields = filteredFields?.filter(one => data["LookUpFields"].some(item => item === one.field));
  const nonSelectedFields = filteredFields?.filter(one => !data["LookUpFields"].some(item => item === one.field));

  // Define function to render the list of fields
  const renderFields = (fields, isSelected) => (
      <div>
          {fields.map((one,ind) => {
              return (!hideArray.includes(one.field) &&
                  <Row sm={12} className="Look-Up-P" key={ind}>
                      <Tooltip color="rgb(54 54 54)" title={one.field}>
                          <Col sm={5}>
                              <span className="Elipsis-Class" style={{fontWeight:"600", color: "#5a6c97", fontSize: "12px"}}>
                                  {(one.field === "Stage" ? "Project Status" : one.field)?.replaceAll("_", " ")?.toUpperCase()}
                              </span>
                          </Col>
                      </Tooltip>
                      <Tooltip
                          color="rgb(54 54 54)"
                          title={getLookUpData(lookUpDeal && lookUpDeal[one.field == "Project_Status" ? "Stage": one.field], "tooltip",one.field)}
                      >
                          <Col sm={5}>
                              {one.field != "Stage" && getLookUpData(lookUpDeal && lookUpDeal[one.field == "Project_Status" ? "Stage": one.field], "table", one.field)}
                          </Col>
                      </Tooltip>
                      <Col sm={2} style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                          <Button 
                            className="Look-Up-Add-Btn"
                              icon={isSelected ? <FontAwesomeIcon style={{ margin: "0px 7px" }} icon={faMinus} /> : <FontAwesomeIcon style={{ margin: "0px 7px" }} icon={faPlus} />}
                              size="middle" 
                              onClick={(e) => {
                                if(accessType=="read"){
                                  message.warning("Action not allowed. You have only read access.") 
                                  return;
                                }
                                  e.stopPropagation();
                                  if (isSelected) {
                                      removeLookUpField(one.field);
                                  } else {
                                      AddLookUpFields(one.field);
                                    }
                              }}
                          />
                      </Col>
                  </Row>
              );
          })}
      </div>
  );

  const content = (
      <div className="Look-Up-Div">
          <div className="Look-Up-Header">
              <span className="Look-Up-Title" style={{ color: "#5a6c97" }}>Add Lookup Fields</span>
              <Search
                  placeholder="Search..."
                  size="small"
                  style={{ width: "100%", color: "#5a6c97", marginTop: "6px" }}
                  value={searchedValue}
                  allowClear
                  onChange={(e) => handleSearchLookUp(e.target.value)}
              />
          </div>

          {/* Render selected fields */}
          <div className="select-non-select-fields">
          <div className="Selected-Fields">
              <h6 style={{ color: "#5a6c97", fontWeight: "bold" }}>Selected Fields</h6>
              {renderFields(selectedFields, true)}
          </div>

          {/* Render non-selected fields */}
          <div className="Non-Selected-Fields" style={{ marginTop: "10px" }}>
              <h6 style={{ color: "#5a6c97", fontWeight: "bold" }}>Available Fields</h6>
              {renderFields(nonSelectedFields, false)}
          </div>
          </div>
      </div>
  );

  return (
      <Popover
          style={{ zIndex: 99990 }}
          onOpenChange={(open) => {
              handleSearchLookUp('')
              console.log("open-->", open)
          }}
          trigger="click"
          overlayClassName={"Look-Up-Container"}
          placement="top"
          content={content}
      >
          <Button 
          className="Add-Lookup-Icon" 
          icon={<FontAwesomeIcon style={{ marginRight: "7px" }} icon={faPlus} />} 
          onClick={(e) => e.stopPropagation()}></Button>
      </Popover>
  );
};
  const hasAccess = canAccess(accessContext, "Tasks", "Preview Blueprint");
  const [popupOpen,setPopupOpen] = useState(false);
  return (
    <div>
      {loader && <Loader/>}
      {/*{showWarningModal()}*/}
      {customePopup()}
      <AntModal
        open={open}
        // open={true}
        wrapClassName={"Add-task-Wrapper"}
        rootClassName="Add-task-Root-Wrapper"
        draggable
        title=""
        maskClosable={false}
        width={300}
        className=""
        style={{ top: 170, borderRadius: 50, right: 50 }}
        onCancel={() => {
          // history.replace('/project/Tasks/defaultView')
          setIsSubTaskView(false);
          setTaskData({ ...taskEmptyTemplate });
          setStatusOptions([]);
          setAccountSelected('')
          setDealSelected('')
          setTaskHistory([]);
          setOpen(false);
        }}
        footer={[<></>]}
      >
        <div className="Task-Modal-Wrapper">
          <div className="Task-Header">
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              { (taskHistory.length > 0 && (taskModalState.action == "edit" || isSubTaskView )) && <span
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                <FontAwesomeIcon
                onClick={() => {
                  handleBack();
                }}
                style={taskHistory.length == 0 ? { cursor: 'not-allowed', color: 'lightgray' } : { cursor: 'pointer' }}
                icon={faArrowLeft}
              />
              </span>}
              {selectedTable!="pipelines" && taskModalState.action != "edit"?<><span
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                <FontAwesomeIcon color="#7a7a7a" icon={faUser} />
                <div>{getAntSelectDropDown("Account")}</div>
              </span>
              <span
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                <FontAwesomeIcon color="#7a7a7a" icon={faFolder} />
                <div>{getAntSelectDropDown("Project")}</div>
              </span></>
              :
              <span style={{display: "flex", alignItems: "center"}}>
                {selectedTable != "pipelines" && getHeaderForDeal(dealSelected)}
                {getBreadCrumbs(taskData)}           
                 </span>
                }
 
              <span
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                <FontAwesomeIcon color="#7a7a7a" icon={faCodeBranch} />
                <div>{getBlueprintsDropDown("TaskFlowId")}</div>
                {selectedBlueprintData &&
                <Popover
                   open={!hasAccess ? false : isBlueprintOpen}
                    onOpenChange={(newOpen) => {
                      if (!hasAccess) {
                        message.error("Permission Denied");
                        return;
                      }
                      setIsBlueprintOpen(newOpen);
                    }}
                  overlayClassName="Task-Flow-View-Popup"
                  content={()=>(
                  <div onMouseDown={(e) => e.stopPropagation()}
                     style={{ width: "60vw", height: "60vh" }} >
                  <Flow
                    showProgress={true}
                    disableMiniMap={true}
                    selectedData={selectedBlueprintData}
                    onSelectedData={()=>{

                    }}
                    onNodeSelect={(node) => {
                    }}
                    onEdgeSelected={(edge) => {
                    }}
                    saveCallback={(res) => {
                    }}
                  />
                  </div>
                  )}
                  title={selectedBlueprintData?.data?.Name?selectedBlueprintData?.data?.Name:"Preview"}
                  trigger="click"
                  overlayStyle={{ width: '60vw', height: '60vh' }}
                >
                <Tooltip title={"Blueprint"}>
                <span
                  onClick={(e) => e.stopPropagation()} 
                    style={{display: "flex",border:  popupOpen ?'1px solid darkgray':'none',
                          boxShadow:popupOpen? "2px 3px #c9c6c6":"none",
                  borderRadius: '3px',width: "1.5rem",height: "-webkit-fill-available",
                  alignItems: "center",justifyContent: "center",cursor: hasAccess ? "pointer" : "not-allowed", opacity: hasAccess ? 1 : 0.5}}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="view-flow-icon"
                    viewBox="0 0 512 512"
                  >
                    <path d="M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z" />
                  </svg>
                </span>
                </Tooltip>
                </Popover>}
              </span>     
              {/* {MissingRoleUsers.length > 0 && RenderInfowithBlink()} */}
            </div>
            <div>
              <div style={{ display: "flex", gap: "10px", alignItems: 'center'}}>
                {!isSubTaskView && (
               <div className={'group-by-footer'} style={{ display: 'flex', alignItems: 'center', fontWeight: '600', color: '#5d6e99' }}>
      <span style={{marginRight: 8, fontSize: '14px', color: 'rgb(98 115 156)'}}>Milestone</span>
      <Switch 
           size="small" 
           title={`${taskData.IsMilestone ? 'This is a milestone task' : 'This is not a milestone task'}`}
           style={{width:'3.2rem', backgroundColor: '#bfbfbf', color: "#5d6e99", fontWeight: '600',  width: '2.4rem', height: '18px',  }}
           checked={taskData.IsMilestone}
           onChange={async (checked) => { 
                    if(!taskData?.PipelineROWID) message.warning('Please select pipeline first!');
                    if(canEdit == "NO" && (selectedTable == 'tasks' || selectedTable == "pipelines")) {
                      message.error("Permission Denied"); 
                      return
                    } 
                    const handleMilestoneChange = (milestoneStatus) => {
                      setTaskData({ ...taskData, IsMilestone: milestoneStatus });
                    }; 
                    
                    if (taskModalState.action == "create") {
                      if (selectedTable == 'tasks') {  
                            handleMilestoneChange(checked ? 1 : 0);  
                        } else {  
                            handleMilestoneChange(checked ? 1 : 0);
                        }  
                    } else { 
                      if (accessType == "read" || accessType == 'none') {
                        message.warning(`Action not allowed. You have ${accessType == 'read' ? 'only Read' : 'No'} access.`);
                        return;
                      }

                      if (selectedTable == 'tasks' ) { 
                            updateTaskData({ ...taskData }, "IsMilestone", checked ? 1 : 0);
                            handleMilestoneChange(checked ? 1 : 0); 
                      } else  {  
                            updateTaskData({ ...taskData }, "IsMilestone", checked ? 1 : 0);
                            handleMilestoneChange(checked ? 1 : 0);  
                      }  
                    }
                  }}
                />
                </div>
              )}
              {taskModalState.action !== "create" && 
                  <RenderSettingsPopoverContent 
                    taskModalState = {taskModalState}
                    taskData = {taskData}
                    setTaskData = {setTaskData}
                    taskEmptyTemplate = {taskEmptyTemplate}
                    setPageRefreshData = {setPageRefreshData}
                    setOpen = {setOpen}
                    selectedTable = {selectedTable}
                    DealName = {DealName}
                    dealSelected = {dealSelected}
                    />
                }
                {
                taskModalState.action == "create" && 
                <Button
                    type="primary"
                    onClick={() => {
                      handleSaveTask(taskData);
                      DealName.current = dealSelected;
                      setOpen(false);
                      dispatch(Socket({trigger:"refresh_task",data:selectedTable}))
                    }}
                    style={{ height: "28px" }}
                    >
                      Save Task
                    </Button> 
                } 
                <Button
                  icon={<CloseOutlined />}
                  onClick={() => {
                    if(taskModalState.action == "edit"){
                      handleSaveTask(taskData);
                    }
                    if(history.location.pathname?.includes("project/Tasks/defaultView")){
                      history.replace('/project/Tasks/defaultView')
                    }else if(history.location.pathname?.includes("setting/pipeline")){
                      history.replace('/setting/pipeline')
                    }
                    DealName.current = dealSelected;
                    setOpen(false);
                    setIsSubTaskView(false);
                    setDependencyRefresh(prev => !prev);
                    setTaskData({ ...taskEmptyTemplate });
                    setStatusOptions([]);
                    setTaskHistory([]);
                    setAccountSelected('');
                    setDealSelected('');
                    // comment.current = {ROWID:null,flag:false};
                    dispatch(Socket({trigger:"refresh_task",data:selectedTable}))
                  }}
                  style={{ height: "28px" }}
                ></Button>
              </div>
            </div>
          </div>
          <div className="Task-Header-Two">
            {[
             {
              label: "STATUS",
              component: (
                <>
                  <div className="Status-Wrapper-Class">
                    <TaskFlowStatus
                     allCriteriaFields={allCriteriaFields}
                      type={"Status"}
                      activeSidebarObject = {sidebarOptions[activitySection]?.open}
                      statusOptions={mainStatusOptions}
                      onChangeStatus={(data)=>{onChangeTransion(data.label,data.comment)}}
                      taskData={taskData}
                      transitions={statusOptions}
                      taskModalState={taskModalState}
                      allCacheRoles={allCacheRoles}
                      lookUpDeal={lookUpDeal}
                      allCacheUserRoles={allCacheUserRoles}
                      transitionEmails={transitionEmails}
                    />
                    </div>
                </>
              ),
            },
             {
                label: "ASSIGNEE",
                component: (
                  <UserPicker
                    open={canEdit == "NO" ? false : undefined}
                    mode="multiple"
                    values={taskData["Assignee"] ? taskData["Assignee"] : ""}
                    onChange={(val) =>{
                      if(accessType=="read"||accessType=='none'){
                        message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
                        return;
                        } else if(canEdit == "NO"){
                          message.error(`Permission Denied`);
                        return;
                        }
                      if(taskModalState.action == "edit"){
                      updateTaskData({...taskData}, "Assignee" , val)
                      }
                      setTaskData({ ...taskData, Assignee: val ? val : ""});
                    }}
                    options={userOptions}
                    rootClassName="table-dropdown"
                    onClear={()=> {
                      if(accessType=="read"||accessType=='none'){
                        message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
                        return;
                        } else if(canEdit == "NO"){
                          message.error(`Permission Denied`);
                        return;
                        }
                      if(taskModalState.action == "edit"){
                      updateTaskData({...taskData}, "Assignee" , "")
                      }
                      setTaskData({ ...taskData, Assignee: "" })
                    }}
                  />
                ),
              },
            {
                label: "PROJECT MANAGER",
                component: (
                  <UserPicker
                    values={taskData["Supervisor"] ? taskData["Supervisor"] : ""}
                    open={canEdit == "NO" ? false : undefined}
                    onChange={(val) =>{
                      if(accessType=="read"||accessType=='none'){
                        message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
                        return;
                        } else if(canEdit == "NO"){
                          message.error(`Permission Denied`);
                        return;
                        }
                      if(taskModalState.action == "edit"){
                        updateTaskData({...taskData}, "Supervisor" , val)
                      }
                      setTaskData({ ...taskData, Supervisor: val ? val : ""})
                    }}
                    options={userOptions}
                    rootClassName="table-dropdown"
                    onClear={()=> {
                      if(accessType=="read"||accessType=='none'){
                        message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
                        return;
                        } else if(canEdit == "NO"){
                          message.error(`Permission Denied`);
                        return;
                        }
                      if(taskModalState.action == "edit"){
                      updateTaskData({...taskData}, "Supervisor" , "")
                      }
                      setTaskData({ ...taskData, Supervisor: "" })
                    }}
                  />
                ),
              },
              {
                label: "PRIORITY",
                component: (
                  <Tooltip color="rgb(54 54 54)" title={taskData["Priority"]}>
                    <Select
                      className="priority-icon"
                      name="Priority"
                      placeholder="Select an option"
                      style={{ width: 200 }}
                      value={taskData["Priority"] ? taskData["Priority"] : "Not Set"}
                      onChange={(val) =>{
                        if(accessType=="read"||accessType=='none'){
                        message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
                        return;
                        } else if(canEdit == "NO"){
                          message.error(`Permission Denied`);
                        return;
                        }
                        if(taskModalState.action == "edit"){
                        updateTaskData({...taskData}, "Priority" , val)
                        }
                        setTaskData({ ...taskData, Priority: val })
                      }}
                      disabled={canEdit == "NO"}
                      optionLabelProp="icon"
                      rootClassName="table-dropdown"
                    >
                      {["Not Set", "Low", "Medium", "High"].map((priority) => (
                        <Option
                          key={priority}
                          value={priority}
                          icon={
                            <FlagFilled
                              style={{ color: getPriorityValue(priority) }}
                              className="Icon"
                            />
                          }
                        >
                          <FlagFilled
                            style={{ color: getPriorityValue(priority) }}
                            className="Icon"
                          />{" "}
                          {priority}
                        </Option>
                      ))}
                    </Select>
                  </Tooltip>
                  ),
              },
              {
                label: "TIME TRACKED",
                component: (<>
                <TimeTracker 
                checkRecordIfAvailable={checkRecordIfAvailable}
                  viewTaskData={taskData}
                  transitionChangeState={transitionChangeState}
                  setTransitionChangeState={setTransitionChangeState}
                  calculateTimeDifference={calculateTimeDifference}
                  open={open} 
                  anotherSessionActiveFlag={anotherSessionActiveFlag}
                  setAnotherSessionActiveFlag={setAnotherSessionActiveFlag}
                  users={userOptions} 
                  setLoader={setLoader}
                  allTasksAndSubtasks={allTasksAndSubtasks} 
                  viewTaskFunction={viewTaskFunction}
                  handleHistoryAdd={handleHistoryAdd}
                  setTimer={setTimer}
                  setStartTimer={setStartTimer}
                  setTimer2={setTimer2}
                  timer3={timer3}
                  formatTime={formatTime}
                  timer2={timer2}
                  timer={timer}
                  clockInterval={clockInterval}
                  startTimer={startTimer}
                  typeOfTask={typeOfTask}
                  setTimer3={setTimer3}
                  lastEntry={lastEntry}
                  setLastEntry={setLastEntry}
                  userList={userList}
                  setUserList={setUserList}
                  description={description}
                  setDescription={setDescription}
                  taskModalState={taskModalState}
                  selectedTable={selectedTable}
                  />                  
                </>),
              },
              {
                label: "TIME ESTIMATE",
                component: (
                  <CustomTimeSelect
                    rootClassName={"Create-Task-TimePicker"}
                    className={"Create-Task-TimePicker-Class"}
                    placement={"top"}
                    taskData={taskData}
                    setTaskData={(time)=>{
                      if(accessType=="read"||accessType=='none'){
                        message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
                        return;
                        }
                      let data = {...taskData}
                      data.TimeEstimate = time
                      if(taskModalState.action == "edit"){
                        updateTaskData(data,"TimeEstimate", time)
                      }
                      setTaskData(data)
                    }}
                  />
                ),
              },
              {
                label: "START/DUE DATE",
                component: <DueDateRangePopover />,
              },
            ].map(({ label, component }) => (
              <div key={label}>
                <p className="Text-Center" style={label == "TIME ESTIMATE" ? {marginBottom : "2px"} : {}}>{label}</p>
                {component}
              </div>
            ))}
          </div>
          <div className="Task-Modal-Body-Wrapper">
            <div className="Task-Modal-Body-Child1">
              <Row className="Task-Modal-Body" sm={12}>
                <Col
                  className="Task-Info-Wrapper"
                  sm={sidebarOptions[activitySection] && taskModalState.action =="edit" && sidebarOptions[activitySection]?.open ? 7 : 12}
                >
                  <Row className="TaskNameWrapper margin-0">
                    <Input
                      className="Task-Name"
                      size="large"
                      placeholder="Task Name"
                      name="TaskName"
                      variant="borderless"
                      value={taskData["TaskName"]}
                      onChange={(e) => {
                        if(accessType=="read"||accessType=='none'){
                        message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
                        return;
                        } else if(canEdit == "NO"){
                          message.error(`Permission Denied`);
                        return;
                        }
                        e.currentTarget.value = (e.currentTarget.value).trimStart();
                        e.currentTarget.value = e.currentTarget.value.replace(/[^0-9a-zA-Z\s()]/g, "");
                        let temp = { ...taskData };
                        temp["TaskName"] = e.currentTarget.value;
                        setTaskData(temp);
                      }}
                    />
                    {selectedTable == "tasks" && <div className="Status-Wrapper-Class">
                    <TaskFlowStatus
                      allCriteriaFields={allCriteriaFields}
                      statusOptions={mainStatusOptions}
                      onChangeStatus={(data)=>{onChangeTransion(data.label,data.comment)}}
                      taskData={taskData}
                      transitions={statusOptions}
                      taskModalState={taskModalState}
                      allCacheRoles={allCacheRoles}
                      lookUpDeal={lookUpDeal}
                      allCacheUserRoles={allCacheUserRoles}
                      transitionEmails={transitionEmails}
                    />
                    </div>}
                  </Row>
                  <div className="stickyDivWrapper">
                    <Row className="TaskDescriptionWrapper margin-0">
                      <CustomeCollapse
                        defaultOpen={[]}
                        items={[
                          {
                            key: "1",
                            label: <Badge color="#1677ff" style={{right:"-13px",top:"50%"}} count={0}>DESCRIPTION</Badge>,
                            children: (
                              <TextArea
                                name="TaskDescription"
                                style={{ border: "none", color:"#5b6c97" }}
                                placeholder="Write description.."
                                value={taskData["TaskDescription"]}
                                onChange={(e) => {
                                  let temp = { ...taskData };
                                  temp["TaskDescription"] = e.currentTarget.value;
                                  setTaskData(temp);
                                }}
                              />
                            ),
                          },
                        ]}
                        rootClassName={''}
                      />
                    </Row>
                    <Row
                      sm={12}
                      className="margin-0"
                      style={{ borderBottom: "1px solid #e4e4e4" }}
                    >
                      <Col sm={7}>
                        <CustomeTaskField
                          name={"PIPELINE:"}
                          icon={<FontAwesomeIcon icon={faUser} />}
                        >
                          <Select
                            mode={""}
                            disabled={(insertBelowData?.flag)||isSubTaskView}
                            style={{ width: 200 }}
                            value={taskData["PipelineROWID"] ? taskData["PipelineROWID"] : null}
                            placeholder="Select Pipeline"
                            onChange={(val) => {
                              if(accessType=="read"||accessType=='none'){
                              message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
                              return;
                              } else if(canEdit == "NO"){
                                message.error(`Permission Denied`);
                              return;
                              }
                              let temp = { ...taskData };
                              temp["PipelineROWID"] = val;
                              if(taskModalState.action == "edit"){
                              updateTaskData({...taskData}, "PipelineROWID" , val)
                              }
                              setTaskData(temp);
                            }}
                            options={allPipelinesData}
                          />
                        </CustomeTaskField>
                        <CustomeTaskField
                          name={"CREATED ON:"}
                          icon={<FontAwesomeIcon icon={faClock} />}
                        >
                          <span
                            style={{
                              fontWeight: "500",
                              opacity: "0.85",
                              padding: "12px",
                              fontSize: "13px"
                            }}
                          >
                            {taskData?.CREATEDTIME
                              ? dayjs(taskData?.CREATEDTIME).format("MM-DD-YYYY")
                              : ""}
                          </span>
                        </CustomeTaskField>
                      </Col>
                    </Row>
                    <Row
                      sm={12}
                      className="margin-0"
                      style={{ borderBottom: "1px solid #e4e4e4" }}
                    >
                      <CustomeCollapse
                        defaultOpen={[]}
                        items={[
                          {
                            key: "1",
                            label: <Badge color="#1677ff" style={{right:"-18px",top:"50%"}} count={(taskData?.InputFields && taskData?.InputFields.length>0?taskData?.InputFields.length:0)
                              +(taskData?.TaskFlowObject?.InputFields && taskData?.TaskFlowObject?.InputFields?.length>0?taskData?.TaskFlowObject?.InputFields?.length:0)}>INPUT FIELDS</Badge>,
                            rightComponent:<>
                              <InputFields
                                accessType={accessType}
                                Module={"TASK"}
                                cardSize={3}
                                onAdd={(obj) => {
                                  let temp={...taskData};
                                  if(obj.isDuplicate){
                                     swal(`The Input Field "${obj.Name}" is already present!!`);
                                     return;
                                  } else {
                                  let arr = [];
                                  if (Array.isArray(temp?.InputFields) && temp?.InputFields?.length > 0) {
                                    arr = [...temp?.InputFields];
                                  }
                                  arr.push(obj);
                                  temp["InputFields"] = arr;
                                  }
                                  setTaskData(temp);
                                }}
                                taskData = {taskData}
                              >
                                <Button className="Add-Input-Icon" icon={<FontAwesomeIcon style={{ marginRight: "7px" }} icon={faPlus} />} onClick={()=>{}}></Button>
                              </InputFields>
                            </>,
                            children: (
                              <>
                              <InputFieldsTable 
                              deal={lookUpDeal}
                              onBlur={e=>{
                                const data2 = {
                                  ROWID: !isSubTaskView ? taskData.TaskROWID : taskData.SubTaskROWID,
                                  InputFields: taskData.InputFields,
                                  TaskFlowObject: taskData.TaskFlowObject,
                                  MODIFIEDBY: userInfo.email_id,
                                };
                                updateTaskFields(data2);
                              }}
                              onDelete={data=>{
                                if(accessType=="read"||accessType=='none'){
                                message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
                                return;
                                }
                               if(data.Module=="TASK"){
                                 let temp={...taskData}
                                 temp["InputFields"]=temp.InputFields.filter(e=>e.id!=data.id);
                                 setTaskData(temp);
                               }
                                }} 
                              onChange={(fields) => {
                                if(accessType=="read"||accessType=='none'){
                                  message.warning(`Action not allowed. You have ${accessType=='read'?'only Read':'No'} access.`) 
                                  return;
                                  } else if(canEdit == "NO"){
                                    message.error(`Permission Denied`);
                                  return;
                                  }
                                  let temp = { ...taskData }
                                  let taskI = fields.filter(e => e.Module == "TASK")
                                  let flowI = fields.filter(e => e.Module != "TASK")
                                  temp["TaskFlowObject"]["InputFields"] = [...flowI];
                                  temp["InputFields"] = [...taskI];
                                  setTaskData(temp);
                                  getBlueprintDataOptions(temp, temp.TaskStatus);
                                }} 
                                readOnly={taskModalState.action!="edit"}  
                                Module={"TASK"} 
                                InputFields={taskData}
                                // handleAttachmentsForEmailAutomation={handleAttachmentsForEmailAutomation}
                                taskInputFieldAttachments={linksForAttachment}
                                />
                             </>
                            ),
                          },
                        ]}
                        rootClassName={''}
                      />
                    </Row>
                    <Row
                      sm={12}
                      className="margin-0"
                      style={{ borderBottom: "1px solid #e4e4e4" }}
                    >
                     <CustomeCollapse
                        defaultOpen={[]}
                        items={[
                          {
                            key: "1",
                            label: <Badge color="#1677ff" style={{right:"-13px",top:"50%"}} count={taskData["LookUpFields"] && taskData["LookUpFields"].length>0?taskData["LookUpFields"].length:0}>LOOK UP FIELDS</Badge>,
                            rightComponent:<>
                              {getTableForLookupFields()}
                            </>,
                            children: (
                              <Row className="look-up-tile-container">
                                <div className="Look-Up-Div">
                                  {taskData["LookUpFields"] && taskData["LookUpFields"]?.map((one) => {
                                    return (
                                      <Row sm={12} className="Look-Up-P" style={{padding: "5px"}}>
                                        <Tooltip color="rgb(54 54 54)" title={one}>
                                          <Col sm={5}>
                                            <span className="Elipsis-Class" style={{fontWeight:"600", color: "#5a6c97", fontSize: "12px"}}>{(one == "Project_Status" ? "Stage": one).replaceAll("_", " ")?.toUpperCase()}</span>
                                          </Col>
                                        </Tooltip>
                                        <Tooltip
                                          color="rgb(54 54 54)"
                                          title={one != "Stage" && getLookUpData(lookUpDeal && lookUpDeal[one == "Project_Status" ? "Stage": one], "tooltip", one)}
                                        >
                                          <Col sm={5}>
                                            {one != "Stage" && getLookUpData(lookUpDeal && lookUpDeal[one == "Project_Status" ? "Stage": one], "table", one)}
                                          </Col>
                                        </Tooltip>
                                        <Col sm={2} style={{textAlign:"end", paddingRight:"3px"}}>
                                          <Button 
                                          className="Look-Up-Table-Btn"
                                          icon={<FontAwesomeIcon style={{ margin: "7px"}} icon={faMinus} />}
                                          size="small" 
                                          onClick={(e)=>{
                                              removeLookUpField(one);
                                          }}
                                          ></Button>
                                        </Col>
                                      </Row>
                                    );
                                  })}
                                </div>
                                </Row>
                            ),
                          },
                        ]}
                        rootClassName={''}
                      />
                    </Row>
                    {/* <Row
                      sm={12}
                      className="margin-15"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        borderBottom: "1px solid #e4e4e4",
                      }}
                    >
                      <Col sm={7}>
                        <CustomeTaskField
                          name={"ATTACHMENTS:"}
                          icon={<FontAwesomeIcon icon={faPaperclip} />}
                        >
                          <Button
                            title="Upload attachments"
                            onClick={() => {
                                setAttachmentModal(!attachmentModal)
                            }}
                            // className="compose-btns"
                            style={{ position: "relative" , color:"#5a6c97"}}
                          >
                            Upload files
                          </Button>
                          <AttachmentModal
                            handleAttachementRemove={handleAttachementRemove}
                            setAttachmentModal={setAttachmentModal}
                            attachmentModal={attachmentModal}
                            handleUploadFiles={handleUploadFiles}
                            // data={props.dealObj}
                            fileNames={fileNames}
                            setFileNames={setFileNames}
                            uploadFiles={uploadFiles}
                          />
                        </CustomeTaskField>
                      </Col>
                      <Col sm={6}>
                      </Col>
                    </Row> */}
                    <div className="sticky-container create-task-tabs">
                      <Row className="margin-15">
                        <Tabs
                          activeKey={activeTab}
                          onTabClick={(key) => {
                            setActiveTab(key);
                          }}
                          defaultActiveKey={isSubTaskView ? "2" : "3"}
                          items={[
                            {
                              label: (
                                <Badge
                                  color="blue"
                                  count={taskData?.SubTasks?.length}
                                  offset={[10, 0]}
                                >
                                  <span>Sub Tasks</span>
                                </Badge>
                              ),
                              key: "1",
                              disabled: isSubTaskView,
                              children: (
                                <SubTaskTab
                                  allPipelineData={allPipelineData}
                                  groupFilter={""}
                                  module={"View Task"}
                                  viewTaskFunction={(data,module) => {
                                    setActiveTab("2");
                                    handleHistoryAdd();
                                    viewTaskFunction(data,module);
                                  }}
                                  updateFlag={updateFlag}
                                  setUpdateFlag={setUpdateFlag}
                                  taskData={taskData}
                                  setOpen={setOpen}
                                  setTaskData={()=>{ 
                                    setIsSubTaskView(true);
                                    handleHistoryAdd();
                                    setTaskModalState({ module: "SUBTASK", action: "create" })
                                    let entryData = {...taskEmptyTemplate};
                                    entryData["TaskROWID"] = taskData.TaskROWID
                                    entryData["PipelineROWID"] = taskData.PipelineROWID
                                    let flowObj= allBlueprintsData?.filter(e=>e.DefaultFlow=="true")[0];
                                    entryData['TaskFlowObject']=flowObj;
                                    entryData['TaskFlowId']=flowObj?.ROWID;
                                    setTaskData(entryData)
                                  }}
                                  key={"Task Name"}
                                  selectedTable={selectedTable}
                                  allBlueprintsData={allBlueprintsData}
                                  subTaskData={subTaskData}
                                  setSubTaskData={setSubTaskData}
                                  isSubTaskView={isSubTaskView}
                                  setIsSubTaskView={setIsSubTaskView}
                                  setPageRefreshData={setPageRefreshData}
                                  refreshData={refreshData}
                                  handleCreateActivity={handleCreateActivity}
                                  setDependencyRefresh={setDependencyRefresh}
                                  allDependeniesData={allDependeniesData}
                                  allTasksAndSubtasks={allTasksAndSubtasks}
                                  dropdownTasksDataCache={dropdownTasksDataCache}
                                  isTaskModalClosed = {isTaskModalClosed}
                                  lookUpDeal = {lookUpDeal}
                                />
                              ),
                            },
                            {
                              label: (
                                <Badge color="blue" offset={[10, 0]}>
                                  <span>Check List</span>
                                </Badge>
                              ),
                              key: "2",
                              children: <Checklist taskData={taskData} selectedTable={selectedTable} activeTab={activeTab}/>,
                            },
                            {
                              label: (
                                <Tooltip title={taskModalState.action == "create"?'Create the task first to add dependency!':'Add Dependency'}>
                                <Badge color="blue" count={(selectedDependenciesCache?.Blocking?.length + selectedDependenciesCache?.WaitingOn?.length)} offset={[10, 0]}>
                                  <span>Dependency</span>
                                </Badge>
                                </Tooltip>
                              ),
                              disabled: taskModalState.action == "create",
                              style:{cursor: taskModalState.action == "create" ? 'not-allowed' : 'pointer'},
                              key: "3",
                              children: <DependencyModal 
                              setLoader={setLoader}
                              taskData={taskData}
                              allDependencies={allDependencies}
                              selectedDependenciesCache={selectedDependenciesCache} 
                              getOptionsForDropdown={getOptionsForDropdown} 
                              handleDeleteDependency={handleDeleteDependency} 
                              allTasksAndSubtasks={allTasksAndSubtasks}
                              selectedDependencies={selectedDependencies}
                              dropdowncount={dropdowncount}
                              dealSelected={selectedTable=='pipelines'?'NoDeal':dealSelected}
                              setSelectedDependencies={setSelectedDependencies}
                              filteredDropdownTasksData={filteredDropdownTasksData}
                              openTaskFromDependencies={openTaskFromDependencies}
                              setDropdownCount={setDropdownCount}
                              dropdownTasksDataCache={dropdownTasksDataCache}
                              setDropdownTasksDataCache={setDropdownTasksDataCache}
                              handleSaveDependencies={handleSaveDependencies}
                              userOptions={userOptions}
                              statusOptions={mainStatusOptions}
                              openTaskData={taskData}
                              getAllDependenciesForTask={getAllDependenciesForTask}
                              handlecreateactivity={handleCreateActivity}
                              />,
                            },
                            selectedTable === "tasks" && taskModalState.action == "edit" && {
                              label: (
                                <Badge color="blue" offset={[10, 0]}>
                                  <span>Attachments</span>
                                </Badge>
                              ),
                              key: "4",
                              children:  <AttachmentModal
                                handleFileAttachments={handleFileAttachments}
                                handleAttachementRemove={handleAttachementRemove}
                                setAttachmentModal={setAttachmentModal}
                                attachmentModal={attachmentModal}
                                handleUploadFiles={handleUploadFiles}
                                data={lookUpDeal}
                                module={"Task"}
                                fileNames={fileNames}
                                setFileNames={setFileNames}
                                uploadFiles={uploadFiles}
                                setRelativePathId={setRelativePathId}
                                relativePathId={relativePathId}
                                TaskId={taskData.hasOwnProperty("SubTaskROWID")?taskData.SubTaskROWID:taskData.TaskROWID}
                                TaskType={taskData.hasOwnProperty("SubTaskROWID")?"SUBTASK":"TASK"}
                                isTaskModalClosed = {isTaskModalClosed}
                                taskData={taskData}
                              /> ,
                            },
                          ].filter(Boolean)}
                        />
                      </Row>
                    </div>
                  </div>
                </Col>
                {activitySection!=-1 && taskModalState.action=="edit" && sidebarOptions[activitySection]?.open  && (
                  <TaskSidebarContentRenderer 
                    taskModalState = {taskModalState} 
                    sidebarOptions = {sidebarOptions} 
                    activitySection = {activitySection} 
                    selectedTable = {selectedTable} 
                    refreshData = {refreshData} 
                    allTasksAndSubtasks = {allTasksAndSubtasks}
                    setRefreshTasksSubtasks = {setRefreshTasksSubtasks}
                    setLoader = {setLoader}
                    isSubTaskView = {isSubTaskView}
                    taskData = {taskData}
                    statusTimeline = {statusTimeline}
                    getParams = {getParams}
                    location = {location}
                    handleNotificationHyperlink = {handleNotificationHyperlink}
                    viewTaskData = {viewTaskData}
                    lookUpDeal = {lookUpDeal}
                    allPipelineData = {allPipelineData}
                    allCacheUserRoles = {allCacheUserRoles}
                    allCacheRoles = {allCacheRoles}
                  />
                )}
              </Row>
            </div>
            <div className="Task-Modal-Body-Child2">
              <div className="Task-Sidebar" sm={2}>
              {sidebarOptions &&
                  sidebarOptions.map((item, i) => {
                    if (item.key === "Settings") {
                      return taskModalState.action === "create" ? (
                        <div
                          className="mb-3 SidebarBtns"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            cursor: "not-allowed",  // Change cursor to indicate non-clickable
                            opacity: 0.5,           // Optional: Make it look disabled
                          }}
                        >
                          {/* <Badge
                            showZero={false}
                            count={i !== 0 ? 0 : 1}
                            color="#ec4242d1"
                            offset={[0, 0]}
                          > */}
                            <Button
                              style={{ border: "none" }}
                              icon={item.icon}
                              disabled  // Disable button click
                            />
                          {/* </Badge> */}
                          <span>{item.key}</span>
                        </div>
                      ) : (
                        <RenderSettingsPopoverContent 
                          taskModalState = {taskModalState}
                          taskData = {taskData}
                          setTaskData = {setTaskData}
                          taskEmptyTemplate = {taskEmptyTemplate}
                          setPageRefreshData = {setPageRefreshData}
                          setOpen = {setOpen}
                          selectedTable = {selectedTable}
                          DealName = {DealName}
                          dealSelected = {dealSelected}
                        />
                      );
                    }
                    return (
                      <div
                        className={`mb-3 SidebarBtns ${activitySection === i ? "active-btn" : ""}`}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                        onClick={(e) => {
                          if (taskModalState.action === "create") {
                            e.preventDefault();
                            return;
                          } 
                          let arr = [...sidebarOptions];
                          arr = arr.map((a, k) => {
                            // a.open=false;
                            if (i == k && a.open) {
                              a.open = false;
                            }else if(i == k && !a.open){
                              a.open = true;
                            }else{
                              a.open = false;
                            }
                            return a;
                          });
                          setSidebarOptions(arr);
                          setActivitySection(i);
                        }}
                      >
                        {/* <Badge
                          showZero={false}
                          count={i !== 0 ? 0 : 1}
                          color="#ec4242d1"
                          offset={[0, 0]}
                        > */}
                          <Button
                            style={{ border: "none" }}
                            disabled={taskModalState.action === "create"}
                            icon={item.icon}
                          />
                        {/* </Badge> */}
                        <span>{item.key}</span>
                      </div>
                    );
                  })}
              {/* <div>{taskModalState.action == "edit" && <ReminderForTasks task={taskData} userOptions={userOptions}/>}</div>
              <div style={{marginTop:'5px'}}>{taskModalState.action == "edit" &&<>Reminder</>}</div> */}
              </div>
            </div>
          </div>
        </div>
      </AntModal>
    </div>
  );
};

export default CreateTaskModal;
